import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import { Modal, Button, Dropdown, ToggleButtonGroup, ToggleButton, Tooltip, OverlayTrigger } from 'react-bootstrap';
import DateRangePicker from '../DateRangePicker/DateRangePicker';
import ReportButton from '../Buttons/ReportButton';
import useFetch from '../../hooks/fetchMSSQL-hook';
import PrekittingForm from '../../components/Modals/PrekittingForm'
import RefundForm from '../../components/Modals/RefundForm'
import moment from 'moment';

export default  ({ filterName, searchFilter, defaultFilter, defaultAdditionalFilter, additionalFilter, reportList, onFilterChange, onSettingsChange, onAdditionalFilterChange, search, totalCount, additionalBarInfo, forNow, isSorted = false, sortFields = [], machineIdsFromCheckbox, refundList, setRefundList, prekitting, reportOptions = {}, toolbarAction = null }) => {

    const [filter, setFilter] = useState(defaultFilter);
    const [settingsFilter, setSettingsFilter] = useState({saveFilters: true, autoLoading: true, additionalFilter: true, flatView: false, rowsPerPage: 100});
    const {fetchMssqlApi} = useFetch();
    const [isFilterOpen, setIsFilterOpen] = useState(false);
    const [filterLoaded, setFilterLoaded] = useState(false);
    const skipFirstSortBy = useRef(true);
    const [settingsLoaded, setSettingsLoaded] = useState(false);
    const [consoleMachines, setConsoleMachines] = useState([]);
    const [machines, setMachines] = useState([]);
    const [showMachineDropdown, setShowMachineDropdown] = useState(false);
    const [machineDropdownSize, setMachineDropdownSize] = useState(() => {
        const savedSize = Number(localStorage.getItem("bal_machineDropdownSize"));
        return Number.isFinite(savedSize) ? Math.min(100, Math.max(0, savedSize)) : 0;
    });
    const [manufacturers, setManufacturers] = useState([]);
    const [maintenanceTypes, setMaintenanceTypes] = useState([]);
    const [terminalTypes, setTerminalTypes] = useState([]);
    const [locations, setLocations] = useState([]);
    const [machineTypes, setMachineTypes] = useState([]);
    const [contractors, setContractors] = useState([]);
    const [categories, setCategories] = useState([]);
    const [recipes, setRecipes] = useState([]);
    const [products, setProducts] = useState([]);
    const [VATs, setVATs] = useState([]);
    const [deposits, setDeposits] = useState([]);
    const [roles, setRoles] = useState([]);
    const [warehouses, setWarehouses] = useState([]);
    const [fiscDocs, setFiscDocs] = useState([]);
    const [cashRegisters, setCashRegisters] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [prepaidGroup, setPrepaidGroup] = useState([]);
    const [prepaidTypes, setPrepaidTypes] = useState([]);
    const [prepaidStatuses, setPrepaidStatuses] = useState([]);
    const [prepaids, setPrepaids] = useState([]);
    const [terminals, setTerminals] = useState([]);
    const [paymentTypes, setPaymentTypes] = useState([]);
    const [machineTags, setMachineTags] = useState([]);
    const [productTags, setProductTags] = useState([]);
    const [users, setUsers] = useState([]);
    const [merchants, setMerchants] = useState([]);
    const [devices, setDevices] = useState([]);
    const [devicesModels, setDevicesModels] = useState([]);
    const [tagNames, setTagNames] = useState([]);
    const [notifications, setNotifications] = useState([]);
    const [notificationLevels, setNotificationLevels] = useState([]);
    const [range, setRange] = useState({start: moment().startOf("day").format("YYYY-MM-DDTHH:mm:ss"), end: moment().endOf("day").format("YYYY-MM-DDTHH:mm:ss")});
    const [filterBody, setFilterBody] = useState({});
    const [filterBarBody, setFilterBarBody] = useState({});
    const [max, setMax] = useState(3);
    const entries = Object.entries(filterBarBody);
    const visible = entries.slice(0, max);
    const hidden = entries.slice(max);
    const filterBarRef = useRef(null);
    const measureRef = useRef(null);
    const moreRef = useRef(null);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);
    const update = (key, value, options = {}) => {
        const { list, nameKey, idKey, idStateKey } = options;
        setFilter(prev => {
            const next = { ...prev };
            if (!list || !nameKey || !idKey || !idStateKey) {next[key] = value; return next}
            if (!value) {next[key] = ""; next[idStateKey] = null; return next}
            const lower = value.toLowerCase();
            const found = list.find(item => String(item[nameKey] ?? "").toLowerCase() === lower);
            if (!found) { return next }
            next[key] = value; next[idStateKey] = found[idKey];
            return next;
        });
    };
    const updateMachine = (key, idStateKey, value, list) => {
        const machine = list.find((m) => `${m.Name} (${m.SerialNo})` === value);
        update(key, machine?.Name ?? value, {list, nameKey: "Name", idKey: "MachineId", idStateKey});
    };
    const rowsPerPage = Number(settingsFilter?.rowsPerPage) || 50;
    const maxPage = Math.max(1, Math.ceil((Number(totalCount) || 0) / rowsPerPage));
    const isLastPage = filter?.page >= maxPage;

    const recalcMax = () => {
        const bar = filterBarRef.current;
        const measure = measureRef.current;
        const more = moreRef.current;
        if (!bar || !measure || !more) return;
        const clientWidth = bar.clientWidth;
        let moreWidth = more?.clientWidth + 10;     
        const children = [...measure.children];
        if (!children.length) return;
        let used = 0;
        let visibleCount = 0;
        const safety = 4;
        for (let child of children) {
            const w = child.getBoundingClientRect().width + 6;
            if (used + w + moreWidth <= clientWidth - safety) {used += w; visibleCount++}
            else break;
        }
        setMax(visibleCount);
    };
    useLayoutEffect(() => {
        recalcMax();
        const ro = new ResizeObserver(() => recalcMax());
        if (filterBarRef.current) ro.observe(filterBarRef.current);
        return () => ro.disconnect();
    }, [filterBarBody]);

    const sortByNameMap = {
        TerminalFullName: "Terminal",
        TerminalSort: "Terminal",
        SerialNo: "Numer seryjny",
        ConfigName: "Nazwa konfiguracji",
        MachineFullName: "Automat",
        CreateDateTime: "Data / czas",
        CreditCardNo: "Nr karty",
        Image: "Zdjęcie",
        EAN: "EAN",
        Name: "Nazwa",
        IsActive: "Aktywny",
        IsIngredient: "Składnik",
        IngredientTypeName: "Typ składnika",
        IngredientQuantity: "Ilość składnika",
        VATName: "Stawka VAT",
        VATCode: "Stawka VAT",
        DepositName: "Kaucja",
        Price: "Cena",
        MachineName: "Automat",
        LocationName: "Lokalizacja",
        MachineTypeName: "Tryb obsługi",
        Temperature: "Temperatura",
        HBSuccessRatio: "Stabilność połączenia",
        TotalSalesCount: "Sprzedaż całkowita",
        ProductNo: "Nr wyboru"
        
    }

    const machineLogTypes = {
        A: "Zmiana nr wyboru",
        B: "Zmiana ceny",
        C: "Nowy wybór",
        D: "Usunięcie wyboru",
        E: "Zmiana stanu",
        F: "Zmiana produktu",
        G: "Zmiana pojemności",
        H: "Wybór zablokowany / odblokowany",
    };

    const priceDeviationSortByNameMap = {
        ProductName: "Produkt / EAN",
        MinPrice: "Cena min.",
        MinMachines: "Automaty z ceną min.",
        LowerDeviation: "Odchylenie dolne",
        AvgPrice: "Średnia cena",
        UpperDeviation: "Odchylenie górne",
        MaxMachines: "Automaty z ceną maks.",
        MaxPrice: "Cena maks.",
        Spread: "Rozpiętość cen",
    };

    const [toggle, setToggle] = useState({cashless: false, cash: false, returned: false});

    const parseThreeState = (val) => {if (val === "false") return false; if (val === "true") return true; return null};
    const valueThreeState = (val) => {if (val === "false") return "Nie"; if (val === "true") return "Tak"; return "Dowolne"};

    const getMachineIdsByTags = (machineTagIds) => {
        return new Promise((resolve, reject) => {
        fetchMssqlApi(
            "tags/getMachineIdsByTags",
            { method: "POST", hideNotification: true, data: { machineTagIds } },
            (response) => { resolve(JSON.stringify(response.map(Number).filter(Number.isFinite)) || [])},
            (err) => reject(err)
        );
        });
    };

    const getProductIdsByTags = (productTagIds) => {
        return new Promise((resolve, reject) => {
        fetchMssqlApi(
            "getProductIdsByTags",
            { method: "POST", hideNotification: true, data: { productTagIds } },
            (response) => { resolve(JSON.stringify(response.map(Number).filter(Number.isFinite)) || [])},
            (err) => reject(err)
        );
        });
    };

    const getFilterBody = async (f) => {
        let body = {};
        let filterBarBody = {};
        if (Object.prototype.hasOwnProperty.call(f, "reportMinDays")) {
            body.reportMinDays = f.reportMinDays;
            filterBarBody[filterName === "unassignedChoicesReport" ? "Zweryfikuj dni (ostatnie)" : "Min. dni bez sprzedaży"] = f.reportMinDays;
        }
        if (Object.prototype.hasOwnProperty.call(f, "reportLimit")) {
            body.reportLimit = f.reportLimit;
            filterBarBody["Limit"] = f.reportLimit;
        }
        if (f.reportMachine?.trim()) {
            body.reportMachine = f.reportMachine.trim();
            filterBarBody["Automat"] = f.reportMachine.trim();
        }
        if (f.reportProduct?.trim()) {
            body.reportProduct = f.reportProduct.trim();
            filterBarBody["Produkt"] = f.reportProduct.trim();
        }
        if (Object.prototype.hasOwnProperty.call(f, "reportProductType")) {
            body.reportProductType = f.reportProductType;
            filterBarBody["Typ automatu"] = f.reportProductType || "Snack";
        }
        if (f.dateTimeRangeFrom) {
            body.fromCreateDateTime = f.dateTimeRangeFrom;
            filterBarBody["Od"] = moment(f.dateTimeRangeFrom).format("DD-MM-YYYY HH:mm");
        }
        if (f.dateTimeRangeTo) {
            body.toCreateDateTime = f.dateTimeRangeTo;
            filterBarBody["Do"] = moment(f.dateTimeRangeTo).format("DD-MM-YYYY HH:mm");
        }
        if (f.isRecalculated !== undefined) {
            body.isRecalculated = parseThreeState(f.isRecalculated);
            filterBarBody["Rozliczone"] = valueThreeState(f.isRecalculated);
        }
        if (f.zeroPA !== undefined) {
            body.isZeroTotal = parseThreeState(f.zeroPA);
            filterBarBody["Zerowe PA"] = valueThreeState(f.zeroPA);
        }
        if (f.telemetry !== undefined) {
            body.isTelemetry = parseThreeState(f.telemetry);
            filterBarBody["Telemetria"] = valueThreeState(f.telemetry);
        }
        if (f.terminalId) {
            body.terminalId = f.terminalId;
        }
        if (f.terminalSerialNo) {
            body.terminalSerialNo = f.terminalSerialNo ? f.terminalSerialNo.split(" ").pop():null;
            filterBarBody[filterName === "impulseTerminals" ? "Nr seryjny" : "Terminal"] = f.terminalSerialNo;
        }
        if (f.configName) {
            body.configName = f.configName;
            filterBarBody["Nazwa konfiguracji"] = f.configName;
        }
        if (f.customerId) {
            body.customerId = f.customerId;
            filterBarBody["Klient"] = f.customerName;
        }
        if (f.terminalTypeId) {
            body.terminalTypeId = f.terminalTypeId;
            filterBarBody["Typ terminali"] = f.terminalTypeName;
        }
        if (f.transactionPeriod) {
            body.transactionPeriod = f.transactionPeriod;
        }
        if (f.paymentTypeId) {
            body.paymentTypeId = f.paymentTypeId;
            filterBarBody["Typ płatności"] = f.paymentTypeName;
        }
        if (f.machineId) {
            body.machineId = f.machineId;
            filterBarBody["Automat"] = f.machineName;
        }

        if (f.consoleMachineId) {
            body.consoleMachineId = f.consoleMachineId;
            filterBarBody["Automat"] = f.consoleMachineName;
        }
        
        if (f.serialNo) {
            body.serialNo = f.serialNo;
            filterBarBody["Nr seryjny"] = f.serialNo;
        }

        const isStatTagReport = filterName === "zeroSalesReport" || filterName === "unassignedChoicesReport";
        if (f.machineId || (!isStatTagReport && f.machineTags?.id?.length > 0)) {
            let machineIds = "[]";
            if (f?.machineTags?.id?.length > 0) { machineIds = await getMachineIdsByTags(f.machineTags.id)}
            if (f?.machineId) {const arr = JSON.parse(machineIds); arr.push(Number(f.machineId)); machineIds = JSON.stringify(arr);}
            body.machineIds = machineIds;
        }

        if (f.productId || f.productTags?.id.length > 0) {
            let productIds = "[]";
            if (f?.productTags?.id?.length > 0) { productIds = await getProductIdsByTags(f.productTags.id)} 
            if (f?.productId) {const arr = JSON.parse(productIds); arr.push(Number(f.productId)); productIds = JSON.stringify(arr);}
            body.productIds = productIds;
        }

        if (f.locationId) {
            body.locationId = f.locationId;
            filterBarBody["Lokalizacja"] = f.locationName;
        }

        if (f.machineTypeId) {
            body.machineTypeId = f.machineTypeId;
            filterBarBody["Typ"] = f.machineTypeName;
        }

        if (f.maintenanceTypeId) {
            body.maintenanceTypeId = f.maintenanceTypeId;
            filterBarBody["Tryb obsługi"] = f.maintenanceName;
        }

        if (f.machineTags?.id?.length > 0) {
            body.machineTags = f.machineTags.id;
            filterBarBody[isStatTagReport ? "Tagi automatów" : "Tagi"] = (f.machineTags.name || []).join(", ");
        }

        if (f.productTags?.id.length > 0) {
            body.productTags = f.productTags?.id?.length ? f.productTags.id : null;
            filterBarBody["Tagi"] = f.productTags?.name?.join(", ");
        }

        if (f.userId) {
            body.createUserId = f.userId;
            filterBarBody["Serwisant"] = f.userName;
        }

        if (f.manufacturerId) {
            body.manufacturerId = f.manufacturerId;
            filterBarBody["Nazwa"] = f.manufacturerName;
        }

        if (f.tagName) {
            filterBarBody["Nazwa"] = f.tagName;
        }

        if (f.contractorId) {
            body.contractorId = f.contractorId;
            filterBarBody["Kontrahent"] = f.contractorName;
        }

        if (f.warehouseId) {
            body.warehouseId = f.warehouseId;
            filterBarBody["Magazyn"] = f.warehouseName;
        }

        if (f.manufacturerId) {
            body.manufacturerId = f.manufacturerId;
            filterBarBody["Kod"] = f.code;
        }

        if (f.merchantMid) {
            body.merchantMid = f.merchantMid;
            filterBarBody["Kontrahent"] = f.merchantName;
        }

        if (f.deviceSN) {
            body.deviceSN = f.deviceSN;
            filterBarBody["Urządzenie"] = f.deviceSN;
        }

        if (f.deviceModel) {
            body.deviceModel = f.deviceModel;
            filterBarBody["Model"] = f.deviceModel;
        }
        if (f.deviceAssignmentStatus) {
            body.deviceAssignmentStatus = f.deviceAssignmentStatus;
            const deviceAssignmentStatusNames = {BOUND: "Powiązane", TERMINAL_ONLY: "Puste terminale", DEVICE_ONLY: "Puste urządzenia", NULL: "Dowolne"};
            filterBarBody["Status powiązania"] = deviceAssignmentStatusNames[f.deviceAssignmentStatus] || f.deviceAssignmentStatus;
        }
        if (f.cashRegisterId) {
            body.cashRegisterId = f.cashRegisterId;
            filterBarBody["Nr unikatowy"] = f.nrUnikName;
        }

        if (f.fiscalDocTypeId) {
            body.fiscalDocTypeId = f.fiscalDocTypeId;
            filterBarBody["Typ dokumentu"] = f.fiscalDocTypeName;
        }

        if (f.prepaidId) {
            body.prepaidId = f.prepaidId;
            filterBarBody["Właściciel karty prepaid"] = f.ownerData;
        }

        if (f.printedCodeName) {
            filterBarBody["Nadrukowany numer karty"] = f.printedCodeName;
        }

        if (f.codeName) {
            filterBarBody["Wewnętrzny numer karty"] = f.codeName;
        }

        if (f.prepaidGroupId) {
            body.prepaidGroupId = f.prepaidGroupId;
            filterBarBody["Nazwa"] = f.prepaidGroupName;
        }

        if (f.prepaidTimespanId) {
            body.prepaidTimespanId = f.prepaidTimespanId;
            filterBarBody["Częstotliwość zasilania"] = f.prepaidTimespanName;
        }

        if (f.prepaidStatusId) {
            body.prepaidStatusId = f.prepaidStatusId;
            filterBarBody["Status"] = f.prepaidStatus;
        }

        if (f.prepaidTypeId) {
            body.prepaidTypeId = f.prepaidTypeId;
            filterBarBody["Typ karty prepaid"] = f.prepaidType;
        }

        if (f.customerId) {
            body.customerId = f.customerId;
            filterBarBody["Klient"] = f.customerName;
        }


        if (f.productId) {
            body.productId = f.productId;
            filterBarBody["EAN"] = f.eanPName;
        }

        if (f.productId) {
            body.productId = f.productId;
            filterBarBody["Nazwa"] = f.productName;
        }

        if (f.categoryId) {
            body.categoryId = f.categoryId;
            filterBarBody["Nazwa"] = f.categoryName;
        }

        if (f.recipeId) {
            body.recipeId = f.recipeId;
            filterBarBody["EAN"] = f.eanRName;
        }

        if (f.recipeId) {
            body.recipeId = f.recipeId;
            filterBarBody["Nazwa"] = f.recipeName;
        }

        if (f.trxStatusTypeId) {
            body.trxStatusTypeId = f.trxStatusTypeId;
            filterBarBody["Status"] = f.trxStatusTypeName;
        }

        if (f.productGroupId) {
            body.productGroupId = f.productGroupId;
            filterBarBody["Grupa"] = f.productGroupName;
        }

        if (f.VATCode) {
            body.VATCode = f.VATCode;
            filterBarBody["Stawka VAT"] = f.VATName;
        }

        if (f.isIngredient !== undefined) {
            body.isIngredient = parseThreeState(f.isIngredient);
            filterBarBody["Składnik"] = valueThreeState(f.isIngredient);
        }
        if (f.isActive !== undefined) {
            body.isActive = parseThreeState(f.isActive);
            filterBarBody["Aktywny"] = valueThreeState(f.isActive);
        }
        if (f.enabled !== undefined) {
            body.enabled = parseThreeState(f.enabled);
            filterBarBody["Włączona"] = valueThreeState(f.enabled);
        }
        if (f.overwriteCredit !== undefined) {
            body.overwriteCredit = parseThreeState(f.overwriteCredit);
            filterBarBody["Nadpisywanie środków"] = valueThreeState(f.overwriteCredit);
        }
        if (f.userId) {
            body.createUserId = f.userId;
            filterBarBody["Serwisant"] = f.userName;
        }
        if (f.machineLogType) {
            body.machineLogType = f.machineLogType;
            filterBarBody["Typ zmiany"] = machineLogTypes[f.machineLogType] || f.machineLogType;
        }
        if (f.machineLogSource) {
            body.machineLogSource = f.machineLogSource;
            filterBarBody["Źródło zmiany"] = f.machineLogSource;
        }
        if (f.notificationName) {
            body.notificationName = f.notificationName;
            filterBarBody["Zdarzenie"] = f.notificationName;
        }
        if (f.notificationDescription) {
            body.notificationDescription = f.notificationDescription;
            filterBarBody["Opis"] = f.notificationDescription;
        }
        if (f.notificationLevelName) {
            body.notificationLevelName = f.notificationLevelName;
            filterBarBody["Poziom powiadomienia"] = f.notificationLevelName;
        }
        if (f.sortBy !=="none" && f.sortBy) {
            body.sortBy = f.sortBy;
            const [curField, curDirRaw] = String(f.sortBy || "none").split("|");
            const columnLabel = filterName === "productPriceDeviationsReport"
                ? priceDeviationSortByNameMap[curField] || sortByNameMap[curField] || curField
                : sortByNameMap[curField] || curField;
            filterBarBody["Sortowanie"] = `${columnLabel} ${curDirRaw.toUpperCase() === "ASC" ? "▲" : "▼"}`;
        }
        if (f.page) body.page = f.page;
        setFilterBarBody(filterBarBody);
        setFilterBody(body)
    }

    const clientId = sessionStorage.getItem("clientId") || "noClient";
    const filterKey = `${clientId}_${filterName}Filter`;
    const settingsFilterKey = `${clientId}_${filterName}SettingsFilter`;

    const loadFilter = () => {
        try {
            const rawSettings = localStorage.getItem(settingsFilterKey);
            if (rawSettings) {const parsedSettings = JSON.parse(rawSettings);
            setSettingsFilter(prev => ({ ...prev, ...parsedSettings }))}
            setSettingsLoaded(true);
            const savedSettings = rawSettings ? JSON.parse(rawSettings) : null;
            const saveEnabled = savedSettings?.saveFilters ?? true;
            if (!saveEnabled) {setFilter(defaultFilter); setFilterLoaded(true); return}
            const rawFilter = localStorage.getItem(filterKey);
            if (!rawFilter) {setFilter(defaultFilter); setFilterLoaded(true); return}
            const parsedFilter = JSON.parse(rawFilter);
            if (
                parsedFilter.dateTimeRangeFrom &&
                parsedFilter.dateTimeRangeTo &&
                moment(parsedFilter.dateTimeRangeFrom).isSame(parsedFilter.dateTimeRangeTo, "day") &&
                moment(parsedFilter.dateTimeRangeFrom).format("HH:mm:ss") === "00:00:00" &&
                moment(parsedFilter.dateTimeRangeTo).format("HH:mm:ss") === "23:59:59" &&
                !moment(parsedFilter.dateTimeRangeFrom).isSame(moment(), "day")
            ) {
                parsedFilter.dateTimeRangeFrom = moment().startOf("day").format("YYYY-MM-DDTHH:mm:ss");
                parsedFilter.dateTimeRangeTo = moment().endOf("day").format("YYYY-MM-DDTHH:mm:ss");
            }
            const mergedFilter = { ...defaultFilter, ...parsedFilter, page: 1 };
            if (filterName === "zeroSalesReport" || filterName === "unassignedChoicesReport") {
                delete mergedFilter.reportTag;
                delete mergedFilter.reportRegion;
                delete mergedFilter.reportRoute;
            }
            setFilter(mergedFilter);
            if (parsedFilter.dateTimeRangeFrom && parsedFilter.dateTimeRangeTo) {
            setRange({ start: parsedFilter.dateTimeRangeFrom, end: parsedFilter.dateTimeRangeTo});}
            setFilterLoaded(true)
        } catch (err) {console.error("Error loading filter from localStorage", err); setFilter(defaultFilter);}
    };

    const saveFilter = () => {
        try {
            localStorage.setItem(settingsFilterKey, JSON.stringify(settingsFilter));
            if (settingsFilter.saveFilters) {localStorage.setItem(filterKey, JSON.stringify(filter))} 
            else {localStorage.removeItem(filterKey);}
        } catch (err) {console.error("Error saving filter to localStorage", err)}
    };

    const FILTER_RENDER_KEYS = [
        "dateTimeRangeFrom",
        "reportMinDays",
        "reportLimit",
        "reportMachine",
        "reportProduct",
        "reportProductType",
        "zeroPA",
        "telemetry",
        "isActive",
        "isRecalculated",
        "terminalId",
        "terminalSerialNo",
        "configName",
        "machineName",
        "notificationName",
        "notificationDescription",
        "notificationLevelName",
        "terminalTypeId",
        "transactionPeriod",
        "paymentTypeId",
        "userName",
        "serialNo",
        "locationName",
        "machineTypeName",
        "maintenanceName",
        "tagName",
        "manufacturerName",
        "code",
        "contractorName",
        "warehouseName",
        "nrUnikName",
        "fiscalDocTypeName",
        "machineTags",
        "roleName",
        "ownerData",
        "printedCodeName",
        "codeName",
        "groupName",
        "prepaidStatus",
        "prepaidType",
        "eanPName",
        "eanRName",
        "productName",
        "recipeName",
        "VATName",
        "customerName",
        "customerId",
        "machineId",
        "machineLogType",
        "machineLogSource",
        "enabled",
        "overwriteCredit",
        "merchantMid",
        "deviceSN",
        "deviceAssignmentStatus"
    ];

    const visibleFiltersCount = FILTER_RENDER_KEYS.filter(k => Object.prototype.hasOwnProperty.call(defaultFilter, k)).length;

    const isSingleFilter = visibleFiltersCount === 1;
    const modalSize = visibleFiltersCount <= 1 ? "sm" : visibleFiltersCount <= 4 ? "lg" : "xl";
    const toggleWrapperClass = isSingleFilter ? "w-100 d-flex flex-column align-items-center" : "";

    const hasDateRange = defaultFilter?.dateTimeRangeFrom && defaultFilter?.dateTimeRangeTo;
    const getMachineTypes = () => {fetchMssqlApi('/machine-types', {}, response => setMachineTypes(response))}
    const getLocations = () => {
  fetchMssqlApi(
    'locations',
    {},
    response => {
      setLocations(
        Array.isArray(response)
          ? response
          : Array.isArray(response?.rows)
            ? response.rows
            : []
      );
    }
  );
};
    const getManufacturers = () => {fetchMssqlApi('manufacturers', {}, response => setManufacturers(response))}
    const getMachines = () => {fetchMssqlApi('machines-list', {}, response => setMachines(response))}
    const getConsoleMachines = () => {fetchMssqlApi('console-machines-list', {}, response => setConsoleMachines(response))}
    const getMachineTags = () => {fetchMssqlApi('tags', {}, response => setMachineTags(response.machine))}
    const getProductTags = () => {fetchMssqlApi('tags', {}, response => setProductTags(response.product))}
    const getMaintenanceTypes = () => {fetchMssqlApi('maintenance-types', {method: 'POST', hideNotification: true, data: {isActive: 1}}, response => setMaintenanceTypes(response))}
    const getUsers = () => {fetchMssqlApi('users-list', {}, response => setUsers(response))}
    const getTerminalTypes = () => {fetchMssqlApi('terminal-type-list', {method: 'POST', hideNotification: true, data: {}}, response => setTerminalTypes(response))}
    const getTerminals = () => {fetchMssqlApi('terminal-list', {method: 'POST', hideNotification: true, data: {}}, response => setTerminals(response))}
    const getPaymentTypes = () => {fetchMssqlApi('payment-type-list', {method: 'POST', hideNotification: true, data: {}}, response => setPaymentTypes(response))}
    const getWarehouses = () => {fetchMssqlApi('warehouses-list', {}, response => setWarehouses(response))}
    const getContractors = () => {fetchMssqlApi('contractors-list', {}, response => setContractors(response))}
    const getRoles = () => {fetchMssqlApi('/roles', {}, response => setRoles(response))}
    const getCashRegisters = () => {fetchMssqlApi('cashRegisters/null', {}, response => setCashRegisters(response))}
    const getFiscDocs = () => {fetchMssqlApi('cashRegisters/reports/types', {}, response => setFiscDocs(response))}
    const getPrepaidTypes = () => {fetchMssqlApi('prepaid-types', {}, response => setPrepaidTypes(response))}
    const getPrepaidStatuses = () => {fetchMssqlApi('prepaid-status', {}, response => setPrepaidStatuses(response))}
    const getPrepaids = () => {fetchMssqlApi('prepaids-filter', {method: 'POST', hideNotification: true, data: {}}, response => setPrepaids(response))}
    const getPrepaidGroup = () => fetchMssqlApi('prepaid-groups', {}, response => setPrepaidGroup(response))
    const getMerchants = () => {fetchMssqlApi('nexgo/merchants', {method: 'POST', hideNotification: true}, response => setMerchants(response?.data?.items))}
    const getDevices = () => {fetchMssqlApi('nexgo/devices', {method: 'POST', hideNotification: true}, response => {setDevices(response?.data?.items); setDevicesModels(response?.data?.items?.filter((item, index, arr) => item?.model && arr.findIndex(x => x?.model === item?.model) === index));})}
    const getCustomers = () => {fetchMssqlApi('customers', {}, response => setCustomers(response))}
    const getProducts = () => {fetchMssqlApi('products', { method: "POST", hideNotification: true, data: {isActive: true}}, response => setProducts(response))}
    const getCategories = () => {fetchMssqlApi('categories', { method: "POST", hideNotification: true, data: {categoryId: null}}, response => setCategories(response))}
    const getRecipes = () => {fetchMssqlApi('recipes', {method: "POST", hideNotification: true, data: {isActive: true}}, response => setRecipes(response))}
    const getVAT = () => {fetchMssqlApi('vats', {method: 'POST', hideNotification: true, data: {isActive: true}}, response => setVATs(response))}
    const getDeposits = () => {fetchMssqlApi('deposits', {method: 'POST', hideNotification: true, data: {isActive: true}}, response => setDeposits(response))}
    const getTagNames = () => {fetchMssqlApi(`tags/list`, {method: "POST", hideNotification: true, data: {}}, response => setTagNames(response))}
        const normalizeNotificationRows = response => {
        if (Array.isArray(response?.[0])) return response[0];
        if (Array.isArray(response)) return response;
        if (Array.isArray(response?.data)) return response.data;
        return [];
    };
    const uniqueByName = (rows, getter, idKey) => {
        const map = new Map();
        rows.forEach((row, index) => {
            const name = String(getter(row) || "").trim();
            if (!name || map.has(name)) return;
            map.set(name, { [idKey]: row?.[idKey] || index + 1, Name: name });
        });
        return Array.from(map.values());
    };
        const getNotifications = () => {
        fetchMssqlApi(
            'notifications',
            {method: 'GET', hideNotification: true},
            response => {
                const rows = normalizeNotificationRows(response);
                setNotifications(uniqueByName(rows, row => row.Name || row.NotificationName, 'NotificationId'));
            }
        )
    }

    const getNotificationLevels = () => {
        fetchMssqlApi(
            'notification-levels',
            {method: 'GET', hideNotification: true},
            response => {
                const rows = normalizeNotificationRows(response);
                setNotificationLevels(uniqueByName(rows, row => row.Name || row.NotificationLevelName || row.LevelName || row.Level, 'NotificationLevelId'));
            }
        )
    }
    useEffect( () => {
        update("dateTimeRangeFrom", range.start);
        update("dateTimeRangeTo", range.end);
    }, [range])

    const setDefaultRange = () => {setRange({start: defaultFilter.dateTimeRangeFrom, end: defaultFilter.dateTimeRangeTo})}

    const applyFilter = () => {
        saveFilter();
        search(filter);
        if (additionalFilter) onAdditionalFilterChange(defaultAdditionalFilter);
        update("page", 1);
        setIsFilterOpen(false);
        getFilterBody(filter);
    };

    const clearFilter = () => {
        localStorage.removeItem(filterKey);
        if (additionalFilter) onAdditionalFilterChange(defaultAdditionalFilter);
        setFilter(defaultFilter);
        setDefaultRange();
        setIsFilterOpen(false);
        search(defaultFilter);
        getFilterBody(defaultFilter)
    }

    const sortOptions = React.useMemo(() => {
    if (!isSorted || !sortFields?.length) return [{ value: "none", label: "Nie" }];

    return [
        { value: "none", label: "Nie" },
        ...sortFields.flatMap(f => ([
        { value: `${f.field}|asc|${f.type || "text"}`, label: `${f.label}  ↑` },
        { value: `${f.field}|desc|${f.type || "text"}`, label: `${f.label}  ↓` },
        ])),
    ];
    }, [isSorted, sortFields]);

    useEffect(() => {
        loadFilter();
        if (Object.keys(defaultFilter).includes("locationId")) getLocations();
        if (Object.keys(defaultFilter).includes("machineId") && clientId !== "console") getMachines();
        if (Object.keys(defaultFilter).includes("consoleMachineId")) getConsoleMachines();
        if (Object.keys(defaultFilter).includes("machineTypeId")) getMachineTypes();
        if (Object.keys(defaultFilter).includes("manufacturerId")) getManufacturers();
        if (Object.keys(defaultFilter).includes("machineTags")) getMachineTags();
        if (Object.keys(defaultFilter).includes("productTags")) getProductTags();
        if (Object.keys(defaultFilter).includes("maintenanceTypeId")) getMaintenanceTypes();
        if (Object.keys(defaultFilter).includes("userId")) getUsers();
        if (Object.keys(defaultFilter).includes("terminalTypeId")) getTerminalTypes();
        if (Object.keys(defaultFilter).includes("terminalId")) getTerminals();
        if (Object.keys(defaultFilter).includes("paymentTypeId")) getPaymentTypes();
        if (Object.keys(defaultFilter).includes("contractorId")) getContractors();
        if (Object.keys(defaultFilter).includes("warehouseId")) getWarehouses();
        if (Object.keys(defaultFilter).includes("fiscalDocTypeId")) getFiscDocs();
        if (Object.keys(defaultFilter).includes("cashRegisterId")) getCashRegisters();
        if (Object.keys(defaultFilter).includes("roleId")) getRoles();
        if (Object.keys(defaultFilter).includes("prepaidTypeId")) getPrepaidTypes();
        if (Object.keys(defaultFilter).includes("prepaidStatusId")) getPrepaidStatuses();
        if (Object.keys(defaultFilter).includes("prepaidId")) getPrepaids();
        if (Object.keys(defaultFilter).includes("prepaidGroupId")) getPrepaidGroup();
        if (Object.keys(defaultFilter).includes("customerId")) getCustomers();
        if (Object.keys(defaultFilter).includes("productId")) getProducts();
        if (Object.keys(defaultFilter).includes("categoryId")) getCategories();
        if (Object.keys(defaultFilter).includes("recipeId")) getRecipes();
        if (Object.keys(defaultFilter).includes("merchantMid")) getMerchants();
        if (Object.keys(defaultFilter).includes("deviceSN", "deviceModel")) getDevices();
        if (Object.keys(defaultFilter).includes("VATCode")) getVAT();
        if (Object.keys(defaultFilter).includes("depositName")) getDeposits();
        if (Object.keys(defaultFilter).includes("tagName")) getTagNames();
        if (Object.keys(defaultFilter).includes("notificationName")) getNotifications();
        if (Object.keys(defaultFilter).includes("notificationLevelName")) getNotificationLevels();
    }, [])

    useEffect(() => {
        saveFilter()
    }, [settingsFilter])

    const isSame = (a, b) => JSON.stringify(a || {}) === JSON.stringify(b || {});
    const syncingFromParentRef = useRef(false);
    const filterRef = useRef(filter);

    useEffect(() => {
        filterRef.current = filter;
    }, [filter]);

    useEffect(() => {
        if (!searchFilter) return;
        if (isSame(filterRef.current, searchFilter)) return;

        syncingFromParentRef.current = true;
        setFilter(searchFilter);
        getFilterBody(searchFilter);
    }, [searchFilter]);

    useEffect(() => {
        if (!onFilterChange) return;
        if (syncingFromParentRef.current) {syncingFromParentRef.current = false; return;}
        if (isSame(filter, searchFilter)) return;
        onFilterChange(filter);
    }, [filter, searchFilter]);

    useEffect(() => {
        if (onSettingsChange) onSettingsChange(settingsFilter);
    }, [settingsFilter]);

    useEffect(() => {
        setFilterBody(prev => ({
            ...prev,
            machineIds: JSON.stringify(machineIdsFromCheckbox)
        }));
    }, [machineIdsFromCheckbox])

    useEffect(() => {
        if (!settingsLoaded) return;
        if (!filterLoaded) return;
        if (settingsFilter.autoLoading === false) return;
        getFilterBody(filter);
        search(filter, settingsFilter?.rowsPerPage);
    }, [settingsLoaded, filterLoaded]);

    const TagsMini = ({ filter, setFilter, list, stateKey = "machineTags", name }) => {
        const [open, setOpen] = React.useState(false);
        const [activeLabel, setActiveLabel] = React.useState(null);
        const [temp, setTemp] = React.useState({ id: [], name: [] });

        const flatTags = React.useMemo(() => {
            return (list || []).flatMap(g =>
            (g.options || []).map(opt => ({
                Id: opt.tagId,
                Name: g.label ? `${g.label} - ${opt.name}` : opt.name
            }))
            );
        }, [list]);

        const grouped = React.useMemo(() => {
            const g = {};
            flatTags.forEach(t => {
            let [label, tagName] = t.Name.split(" - ");
            if (!tagName) {
                label = "Inne";
                tagName = t.Name.trim();
            }
            if (!g[label]) g[label] = [];
            g[label].push({ Id: t.Id, Name: tagName });
            });
            return g;
        }, [flatTags]);

        const labels = Object.keys(grouped);
        const openModal = () => {
            const fromFilter = filter?.[stateKey] ?? { id: [], name: [] };
            setTemp({
                id: Array.isArray(fromFilter.id) ? [...fromFilter.id] : [],
                name: Array.isArray(fromFilter.name) ? [...fromFilter.name] : [],
            });
            setActiveLabel(null);
            setOpen(true);
        };
        const toggle = (tag, activeLabel) => {
            const tagFullName = `${activeLabel} - ${tag.Name}`;

            setTemp(prev => {
            const exists = prev.id.includes(Number(tag.Id));
            if (exists) {
                return {
                id: prev.id.filter(x => x !== Number(tag.Id)),
                name: prev.name.filter(x => x !== tagFullName),
                };
            }
            return {
                id: [...prev.id, Number(tag.Id)],
                name: [...prev.name, tagFullName],
            };
            });
        };

        const clearTemp = () => {
            const empty = { id: [], name: [] };
            setTemp(empty);
            setFilter(prev => ({
                ...prev,
                [stateKey]: empty
            }));
            setOpen(false);
        };
        const apply = () => {
            setFilter(prev => ({
            ...prev,
            [stateKey]: { id: temp.id, name: temp.name },
            }));
            setOpen(false);
        };

        const removeSelected = (index) => {
            setFilter(prev => {
                const current = prev?.[stateKey] || { id: [], name: [] };
                return {
                    ...prev,
                    [stateKey]: {
                        id: current.id.filter((_, i) => i !== index),
                        name: current.name.filter((_, i) => i !== index)
                    }
                };
            });
        };

        const cancel = () => setOpen(false);

        return (
            <div>
            <h6 className="text-center">{name}</h6>
            <div className="d-flex flex-wrap mb-1" style={{ maxHeight: "12rem", overflow: "auto" }}>
                {filter?.[stateKey]?.name?.map((t, i) => (
                    <button key={i} type="button" className="btn btn-primary badge badge-pill px-2 p-2 my-1 mr-1 font-weight-bold tag-badge" onClick={() => removeSelected(i)}>{t}</button>
                ))}
                <button type="button" className="btn btn-outline-primary badge badge-pill px-3 p-2 my-1 mr-1" onClick={openModal}>
                    <i className="fas fa-plus" />
                </button>

                {(filter?.[stateKey]?.id?.length > 0) && (
                <button
                    type="button"
                    className="btn btn-outline-danger badge badge-pill px-3 p-2 my-1"
                    onClick={() =>
                    setFilter(prev => ({ ...prev, [stateKey]: { id: [], name: [] } }))
                    }
                >
                    <i className="fas fa-times" />
                </button>
                )}
            </div>
            <Modal show={open} onHide={cancel} centered backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                <h6 className="m-0">Tagi</h6>
                </Modal.Header>

                <Modal.Body className="p-0">
                <div className="row m-0 p-0">
                    <div className="col-6 border-right overflow-auto p-0" style={{ maxHeight: 250 }}>
                    {labels.map((lab, i) => (
                        <div key={i} className={`list-group-item list-group-item-action cursor-pointer font-weight-bold ${activeLabel === lab ? "active" : ""}`} onClick={() => setActiveLabel(prev => (prev === lab ? null : lab))}>
                            {lab}
                        </div>
                    ))}
                    </div>
                    {activeLabel && (
                    <div className="col-6 overflow-auto p-0" style={{ maxHeight: 250 }}>
                        {grouped[activeLabel].map(tag => {
                        const selected = temp.id.includes(Number(tag.Id));
                        return (
                            <div
                            key={tag.Id}
                            className={`list-group-item cursor-pointer font-weight-bold ${
                                selected ? "list-group-item-success" : ""
                            }`}
                            onClick={() => toggle(tag, activeLabel)}
                            >
                            {tag.Name}
                            </div>
                        );
                        })}
                    </div>
                    )}
                </div>
                </Modal.Body>

                <Modal.Footer className="d-flex justify-content-between">
                <button type="button" className="btn btn-outline-danger" onClick={clearTemp}>
                    Wyczyść
                </button>
                <div>
                    <button type="button" className="btn btn-secondary mr-2" onClick={cancel}>
                    Anuluj
                    </button>
                    <button type="button" className="btn btn-primary" onClick={apply}>
                    Wybierz
                    </button>
                </div>
                </Modal.Footer>
            </Modal>
            </div>
        );
    };

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth < 992);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const uniqueTimespans = React.useMemo(() => {
    const map = new Map();
    prepaidGroup.forEach(g => {
        if (g.PrepaidTimespanId && !map.has(g.PrepaidTimespanId)) {
        map.set(g.PrepaidTimespanId, {
            id: g.PrepaidTimespanId,
            name: g.PrepaidTimespanName,
        });
        }
    });
    return Array.from(map.values());
    }, [prepaidGroup]);

    const trxStatusTypes = [{ TrxStatusTypeId: 1, Name: "Pozytywna" }, { TrxStatusTypeId: 2, Name: "Zwrot" }, { TrxStatusTypeId: 3, Name: "Odmowa" }];

    const machineDropdownRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (machineDropdownRef.current && !machineDropdownRef.current.contains(e.target)) setShowMachineDropdown(false);
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div>
            <div className="d-flex justify-content-center position-relative">
                <div className="d-flex flex-row" style={{ width: "47%" }}>
                    {Object.keys(defaultFilter).includes("page") && (<>
                        <Button variant="outline-primary" className={`fas fa-xs fa-angle-double-left mt-1 mb-1 pr-2 pl-2 border-0 ${filter?.page === 1 && "pe-none text-dark"}`} onClick={() => {update("page", 1); search(filter, settingsFilter?.rowsPerPage, 1)}}/>
                        <Button variant="outline-primary" className={`fas fa-xs fa-chevron-left mt-1 mb-1 pr-2 pl-2 border-0 ${filter?.page === 1 && "pe-none text-dark"}`} onClick={() => {update("page", filter?.page-1); search(filter, settingsFilter?.rowsPerPage, filter?.page-1)}}/>
                        <Button variant="outline-primary" className="fas fa-xs m-0 border-0 pe-none" style={{fontFamily: "Poppins", fontSize: "16px", fontStyle:"normal", minWidth: "42px"}}>{filter?.page}</Button>
                        <Button variant="outline-primary" className={`fas fa-xs fa-chevron-right mt-1 mb-1 pr-2 pl-2 border-0 ${(settingsFilter?.rowsPerPage > totalCount) && "pe-none text-dark"}`} onClick={() => {update("page", filter?.page+1); search(filter, settingsFilter?.rowsPerPage, filter?.page+1)}}/>
                    </>)}
                    {(additionalBarInfo?.TotalSuccessedVend > 0 || additionalBarInfo?.TotalReturnedVend > 0) && !isMobile && (
                    <div className="d-flex flex-row justify-content-center">
                        <div>
                            <div className="d-flex badge badge-success m-1 py-1 px-2 justify-content-center align-items-center rounded-pill" style={{cursor: "pointer", height: "26px"}} onClick={() => setToggle(prev => ({ ...prev, cashless: !prev.cashless }))}>
                                <i className="fas fa-s fa-credit-card mr-1"/>{toggle.cashless ? (<>{additionalBarInfo?.TotalCashlessSuccessedVend} szt.</>) : <>{Intl.NumberFormat("pl-PL", { style: "currency", currency: "PLN" }).format(additionalBarInfo?.TotalCashlessSuccessedSales)}</>}
                            </div>
                        </div>
                        <div>
                            <div className="d-flex badge badge-success m-1 py-1 px-2 justify-content-center align-items-center rounded-pill" style={{cursor: "pointer", height: "26px"}} onClick={() => setToggle(prev => ({ ...prev, cash: !prev.cash }))}>
                                <i className="fas fa-s fa-coins mr-1"/>{toggle.cash ? (<div>{additionalBarInfo?.TotalCashSuccessedVend} szt.</div>) : <div>{Intl.NumberFormat("pl-PL", { style: "currency", currency: "PLN" }).format(additionalBarInfo?.TotalCashSuccessedSales)}</div>}
                            </div>
                        </div>
                        <div>
                            <div className="d-flex badge badge-danger m-1 py-2 px-2 justify-content-center align-items-center rounded-pill" style={{cursor: "pointer", height: "26px"}} onClick={() => setToggle(prev => ({ ...prev, returned: !prev.returned }))}>
                                <i className="fas fa-undo-alt mr-1"/>{toggle.returned ? (<div>{additionalBarInfo?.TotalReturnedVend} szt.</div>) : <div>{Intl.NumberFormat("pl-PL", { style: "currency", currency: "PLN" }).format(additionalBarInfo?.TotalReturnedSales)}</div>}
                            </div>
                        </div>
                        </div>
                    )}
                </div>
                <div className="d-flex justify-content-center" style={{ width: "9%" }}>
                    {prekitting && (<PrekittingForm/>)}
                    <Button variant="light" className='fas fa-sync text-primary p-0 m-1' style={{ border: "transparent", backgroundColor: "transparent", boxShadow: "none", outline: "none" }} onClick={() => {search(filter, Number(settingsFilter?.rowsPerPage), 1, true); getFilterBody(filter)}}/>
                    <Button variant="light" className='fas fa-filter text-primary p-0 m-1' style={{ border: "transparent", backgroundColor: "transparent", boxShadow: "none", outline: "none" }} onClick={() => setIsFilterOpen(true)}/>
                    {(JSON.stringify(defaultFilter) !== JSON.stringify(filter) || JSON.stringify(defaultAdditionalFilter) !== JSON.stringify(additionalFilter)) && (<Button variant="light" className='fas fa-times-circle text-danger p-0 m-1' style={{ border: "transparent", backgroundColor: "transparent", boxShadow: "none", outline: "none" }} onClick={() => clearFilter()}/>)}
                    {isMobile && (entries?.length > 0) && (
                    <OverlayTrigger placement="bottom" overlay={<Tooltip id="filter-tooltip">{entries.map(([l, v]) => (<div key={l}><strong style={{fontWeight: "800"}}>{l}:</strong> {String(v)}</div>))}</Tooltip>}>
                        <span className="d-flex justify-content-center align-items-center text-dark px-2 m-1 rounded-pill" style={{fontFamily: "Poppins", fontWeight: "700", cursor:"pointer", zIndex: 2, background:"#e9ecef"}}>
                            <i className="fas fa-list"/>
                        </span>
                    </OverlayTrigger>)}
                </div>
                <div style={{ width: "47%" }}>
                    <Dropdown className="float-right" drop="down" autoFocus={false} >
                        <Dropdown.Toggle variant="primary" id="settings-dropdown" className="p-0 m-1" style={{ minWidth: "50px", height: "26px"}}>
                            <i className="fas fa-sliders-h" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="p-1 m-1" popperConfig={{strategy: "fixed", placement: "bottom-end"}}>
                            <Dropdown.Item as="button" className={settingsFilter.saveFilters ? "bg-primary text-white mb-1" : "bg-light mb-1"}  onClick={() => setSettingsFilter(prev => ({...prev, saveFilters: !prev.saveFilters}))}><i className="fas fa-filter"/> Zapisywanie filtrów</Dropdown.Item>
                            <Dropdown.Item as="button" className={settingsFilter.autoLoading ? "bg-primary text-white mb-1" : "bg-light mb-1"} onClick={() => setSettingsFilter(prev => ({...prev, autoLoading: !prev.autoLoading}))}><i className="fas fa-sync-alt"/> Automatyczne ładowanie</Dropdown.Item>
                            {!forNow && (<Dropdown.Item as="button" className={settingsFilter.additionalFilter ? "bg-primary text-white mb-1" : "bg-light mb-1"} onClick={() => setSettingsFilter(prev => ({...prev, additionalFilter: !prev.additionalFilter}))}><i className="fas fa-search-plus"/> Dodatkowe filtrowanie listy</Dropdown.Item>)}
                            {!forNow && (<Dropdown.Item as="button" className={settingsFilter.flatView ? "bg-primary text-white mb-1" : "bg-light mb-1"}  onClick={() => setSettingsFilter(prev => ({...prev, flatView: !prev.flatView}))}><i className="fas fa-table"/> Widok uproszczony</Dropdown.Item>)}
                            <Dropdown.Item as="button" className="pt-0 pb-0 bg-light text-dark pe-none pr-0">
                                <div className="d-flex align-items-center" onClick={e => e.stopPropagation()}>
                                    <i className="fas fa-list mr-1"/><div className="pr-4">Liczba wyników</div>
                                    <select className="form-control form-control-sm pe-auto" value={settingsFilter.rowsPerPage} onChange={e => {const value = Number(e.target.value); setSettingsFilter(prev => ({...prev, rowsPerPage: value})); setFilter(prev => ({...prev, page: 1})); search(filter,value, 1)}}>
                                        <option value={10}>10</option>
                                        <option value={25}>25</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                        <option value={1000}>1000</option>
                                        <option value={5000}>5000</option>
                                        <option value={10000}>10000</option>
                                    </select>
                                </div>
                            </Dropdown.Item>
                            {refundList && (<RefundForm list={refundList} setList={setRefundList}/>)}
                        </Dropdown.Menu>
                    </Dropdown>
                    {toolbarAction && (
                        <div className="float-right d-flex align-items-center mr-3" style={{ height: "34px" }}>
                            {toolbarAction}
                        </div>
                    )}
                    {!!reportList && (
                    <Dropdown className="float-right" drop="down">
                        <Dropdown.Toggle variant="primary" id="reports-dropdown" className="p-0 m-1" style={{ minWidth: "50px", height: "26px"}}>
                            <i className="fas fa-download" />
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="p-0 m-0" style={{ minWidth: "80px", maxHeight: "500px", overflowY: "auto", overflowX: "hidden"}} align="end">
                            <div className="d-flex flex-column">
                                {reportList?.map(r => (
                                <ReportButton key={r.reportId} reportId={r.reportId} btnColor={r.reportColor} body={filterBody} isPrimary showNumber/>
                                ))}
                            </div>
                        </Dropdown.Menu>
                    </Dropdown>
                    )}
                    <div>
                        <div ref={filterBarRef} style={{display:"flex", gap:"6px", overflow:"hidden", whiteSpace:"nowrap", alignItems:"center", padding:"4px"}}>
                            {!isMobile && (<>
                                 {visible.map(([label, value]) => (<span key={label} className="rounded-pill p-1 px-2" style={{fontSize: "12px", background:"#e9ecef" , fontWeight: "500" }}><b>{label}:</b> {String(value)}</span>))}
                            {(hidden.length > 0) ? (
                                <OverlayTrigger placement="bottom" overlay={<Tooltip id="filter-tooltip">{hidden.map(([l, v]) => (<div key={l}><strong>{l}:</strong> {String(v)}</div>))}</Tooltip>}>
                                    <span ref={moreRef} style={{background:"#e9ecef", borderRadius:"16px", padding:"4px 10px", fontSize:"12px", cursor:"pointer", display:"inline-block", whiteSpace:"nowrap", fontWeight:"500"}}>+{hidden.length} więcej</span>
                                </OverlayTrigger>
                            ): <span ref={moreRef}></span>}
                            </>)}
                        </div>
                        <div ref={measureRef} style={{position: "absolute", top: -9999, left: -9999, visibility: "hidden", whiteSpace: "nowrap", display: "flex", gap: "6px", padding: "4px",pointerEvents: "none",}}>
                        {Object.entries(filterBarBody).map(([label, value]) => (
                            <span key={label} className="border-2 p-1" style={{fontSize: "12px"}}>
                                <b style={{fontWeight:"800"}}>{label}:</b> {String(value)}
                            </span>
                        ))}
                        </div>
                    </div>
                </div>
            </div>
            {(additionalBarInfo?.TotalSuccessedVend > 0 || additionalBarInfo?.TotalReturnedVend > 0) && isMobile && (
            <div className="d-flex flex-row justify-content-between align-items-center">
                <div className='d-flex justify-content-start'>
                    <div className="d-flex badge badge-success px-2 m-1 rounded-pill align-items-center" style={{height: "26px"}} onClick={() => setToggle(prev => ({ ...prev, cashless: !prev.cashless }))}>
                        <i className="fas fa-s fa-credit-card mr-1"/>{toggle.cashless ? (<div>{additionalBarInfo?.TotalCashlessSuccessedVend} szt.</div>) : <div>{Intl.NumberFormat("pl-PL", { style: "currency", currency: "PLN" }).format(additionalBarInfo?.TotalCashlessSuccessedSales)}</div>}                            </div>
                </div>
                <div className='d-flex justify-content-center'>
                    <div className="d-flex badge badge-success px-2 m-1 rounded-pill align-items-center" style={{height: "26px"}} onClick={() => setToggle(prev => ({ ...prev, cash: !prev.cash }))}>
                        <i className="fas fa-s fa-coins mr-1"/>{toggle.cash ? (<div>{additionalBarInfo?.TotalCashSuccessedVend} szt.</div>) : <div>{Intl.NumberFormat("pl-PL", { style: "currency", currency: "PLN" }).format(additionalBarInfo?.TotalCashSuccessedSales)}</div>}
                    </div>
                </div>
                <div className='d-flex justify-content-end'>
                    <div className="d-flex badge badge-danger px-2 m-1 rounded-pill align-items-center" style={{height: "26px"}} onClick={() => setToggle(prev => ({ ...prev, returned: !prev.returned }))}>
                        <i className="fas fa-undo-alt mr-1"/>{toggle.returned ? (<div>{additionalBarInfo?.TotalReturnedVend} szt.</div>) : <div>{Intl.NumberFormat("pl-PL", { style: "currency", currency: "PLN" }).format(additionalBarInfo?.TotalReturnedSales)}</div>}
                    </div>
                </div>
            </div>
            )}
            <Modal show={isFilterOpen} size={modalSize} centered backdrop="static">
                {!isMobile && (
                <Modal.Header className="justify-content-center p-0 mr-2 ml-2 mt-1 mb-1">
                    <Modal.Title className="m-0 p-0"><i className='fas fa-filter'/>Filtry</Modal.Title>
                </Modal.Header>
                )}
                <Modal.Body className="pt-1 pl-2 pr-2">
                    <div className="d-flex row justify-content-center">
                        {hasDateRange && (
                            <div className={visibleFiltersCount > 4 ? ("col-12 col-lg-6 col-xl-4 col-xxl-3 p-0") : ("col-12 col-lg-6 col-xl-6 col-xxl-3 p-0")}>
                                <DateRangePicker range={range} setRange={setRange} timeSpan={3} boxStyle={`pr-3 py-1 ${isMobile ? `pl-3` : `pl-0`}`}/>
                            </div>
                        )}
                        <div className={hasDateRange ? (visibleFiltersCount > 4 ? "col-12 col-lg-6 col-xl-8 col-xxl-9 row px-2 justify-content-center" : "col-12 col-lg-6 col-xl-6 col-xxl-9 row px-2 justify-content-center") : "col-12 row px-2 justify-content-center"}>
                        
                        {Object.prototype.hasOwnProperty.call(defaultFilter, "reportMinDays") && (
                            <div className="col-12 col-lg-6 col-xl-4 px-2 py-1">
                                <h6 className="d-flex justify-content-center">
                                    {filterName === "unassignedChoicesReport" ? "Zweryfikuj dni (ostatnie)" : "Min. dni bez sprzedaży"}
                                </h6>
                                <input
                                    className="form-control rounded-0"
                                    type="number"
                                    min={1}
                                    max={filterName === "unassignedChoicesReport" ? 3650 : 365}
                                    value={filter.reportMinDays ?? ""}
                                    onChange={(e) => update("reportMinDays", e.target.value)}
                                />
                            </div>
                        )}
                        {Object.prototype.hasOwnProperty.call(defaultFilter, "reportLimit") && (
                            <div className="col-12 col-lg-6 col-xl-4 px-2 py-1">
                                <h6 className="d-flex justify-content-center">Limit</h6>
                                <select className="form-control rounded-0" value={filter.reportLimit ?? 100}
                                    onChange={(e) => update("reportLimit", Number(e.target.value))}>
                                    {[25, 50, 100, 500, 1000, ...(filterName === "unassignedChoicesReport" ? [2000] : [])].map((n) => (
                                        <option value={n} key={n}>{n}</option>
                                    ))}
                                </select>
                            </div>
                        )}
                        {[
                            { field: "reportProduct", label: "Produkt", list: "products", placeholder: "Wybierz produkt lub wpisz nazwę / EAN" },
                            { field: "reportMachine", label: "Automat", list: "machines", placeholder: "Wybierz automat lub wpisz nazwę / numer" },
                            { field: "machineTags", label: "Tagi Automatów", type: "tags" }
                        ].filter(item => Object.prototype.hasOwnProperty.call(defaultFilter, item.field) && (item.field !== "machineTags" || filterName === "zeroSalesReport" || filterName === "unassignedChoicesReport")).map((item) => item.type === "tags" ? (
                            <div className="col-12 col-lg-6 col-xl-4 px-2 py-1" key={item.field}>
                                <TagsMini filter={filter} setFilter={setFilter} list={machineTags} stateKey="machineTags" name={item.label}/>
                            </div>
                        ) : (
                            <div className="col-12 col-lg-6 col-xl-4 px-2 py-1" key={item.field}>
                                <h6 className="d-flex justify-content-center">{item.label}</h6>
                                <div className="d-flex flex-row">
                                    <input
                                        className="form-control rounded-0"
                                        placeholder={item.placeholder}
                                        list={`${filterName}-${item.field}-options`}
                                        value={filter[item.field] || ""}
                                        autoComplete="off"
                                        onChange={(e) => update(item.field, e.target.value)}
                                    />
                                    {!!filter[item.field] && (
                                        <button type="button" className="btn btn-outline-danger rounded-0"
                                            title={`Wyczyść: ${item.label}`} onClick={() => update(item.field, "")}>
                                            <i className="fas fa-times" />
                                        </button>
                                    )}
                                </div>
                                <datalist id={`${filterName}-${item.field}-options`}>
                                    {(reportOptions[item.list] || []).map((entry, idx) => {
                                        const value = typeof entry === "string" ? entry : entry?.label;
                                        return value ? <option key={`${idx}-${value}`} value={value} /> : null;
                                    })}
                                </datalist>
                            </div>
                        ))}
                        {Object.prototype.hasOwnProperty.call(defaultFilter, "reportProductType") && (
                            <div className="col-12 col-lg-6 col-xl-4 px-2 py-1">
                                <h6 className="d-flex justify-content-center">Typ automatu</h6>
                                <select
                                    className="form-control rounded-0"
                                    value={filter.reportProductType || "Snack"}
                                    onChange={(e) => update("reportProductType", e.target.value)}
                                >
                                    <option value="Wszystkie">Wszystkie</option>
                                    <option value="Kawa">Kawa</option>
                                    <option value="Snack">Snack</option>
                                </select>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("terminalId") && (
                             <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Terminal</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.terminalSerialNo === "") && "col-11"}`} list="terminalSerialNoList" placeholder="Szukaj..." defaultValue={filter?.terminalSerialNo} onChange={(e) => update("terminalSerialNo", e.target.value, {list: terminals, nameKey: "Name", idKey: "TerminalId", idStateKey: "terminalId"})}/>
                                    {!(filter?.terminalSerialNo === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; update("terminalSerialNo", input.value, {list: terminals, nameKey: "Name", idKey: "TerminalId", idStateKey: "terminalId"})}}/>)}
                                </div>
                                <datalist id="terminalSerialNoList">
                                    {terminals?.map((t, i) => (<option key={i} value={t.Name}/>))}
                                </datalist>
                            </div>
                            
                        )}
                        {Object.keys(defaultFilter).includes("machineName") && ( 
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"} ref={machineDropdownRef}>  
                                <div className="d-flex justify-content-center align-items-center mb-2">
                                    <h6 className="m-0">Automat</h6>
                                    {clientId === "bal" && (
                                        <input
                                            type="range"
                                            min="0"
                                            max="100"
                                            step="5"
                                            value={machineDropdownSize}
                                            className="machine-dropdown-size-slider ml-2"
                                            title="Rozmiar listy automatów i czcionki"
                                            aria-label="Rozmiar listy automatów i czcionki"
                                            onChange={(e) => {
                                                const size = Number(e.target.value);
                                                setMachineDropdownSize(size);
                                                localStorage.setItem("bal_machineDropdownSize", String(size));
                                            }}
                                        />
                                    )}
                                </div>
                                <div className="d-flex flex-row position-relative" style={{
                                    "--machine-dropdown-extra-width": `${machineDropdownSize * 4}px`,
                                    "--machine-dropdown-font-size": `${12 + machineDropdownSize * 0.08}px`
                                }}>  
                                    <input className={`form-control rounded-0 ${!(filter?.machineName === "") && "col-11"}`} list={sessionStorage.getItem("clientId") !== "bal" ? "machineNameList" : undefined} placeholder="Szukaj..." value={filter?.machineName || ""} onClick={() => sessionStorage.getItem("clientId") === "bal" && setShowMachineDropdown(prev => !prev)} onChange={(e) => {const value = e.target.value; setFilter(prev => ({...prev, machineName: value, machineId: machines.find(m => m.Name === value)?.MachineId || null})); if (sessionStorage.getItem("clientId") === "bal") setShowMachineDropdown(true)}}/>  
                                    {!(filter?.machineName === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={() => {setFilter(prev => ({...prev, machineName: "", machineId: null})); setShowMachineDropdown(false)}}/>)}  
                                    {sessionStorage.getItem("clientId") === "bal" && showMachineDropdown && (  
                                        <div className="customDropdown custom-scroll">  
                                            {machines?.filter((m) => {  
                                                const search = (filter?.machineName || "").toLowerCase();  
                                                return m.Name?.toLowerCase().includes(search) || m.SerialNo?.toLowerCase().includes(search);  
                                            }).map((m) => (  
                                                <div className="customDropdownOption" key={m.MachineId} onMouseDown={(e) => {e.preventDefault(); setFilter(prev => ({...prev, machineName: m.Name, machineId: m.MachineId})); setShowMachineDropdown(false)}}>  
                                                    {m.Name} - {m.SerialNo}  
                                                </div>  
                                            ))}  
                                        </div>  
                                    )}  
                                </div>  
                                {sessionStorage.getItem("clientId") !== "bal" && (  
                                <datalist id="machineNameList">  
                                    {machines?.map((m) => (<option key={m.MachineId} value={m.Name}/>))}  
                                </datalist>  
                                )}  
                            </div>  
                        )}
                        {Object.keys(defaultFilter).includes("serialNo") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Nr seryjny</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.serialNo === "") && "col-11"}`} list="serialNoList" placeholder="Szukaj..." defaultValue={filter?.serialNo} onChange={(e) => update("serialNo", e.target.value, {list: machines, nameKey: "SerialNo", idKey: "MachineId", idStateKey: "machineId"})}/>
                                    {!(filter?.serialNo === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; update("serialNo", "", {list: machines, nameKey: "SerialNo", idKey: "MachineId", idStateKey: "machineId"})}}/>)}
                                </div>
                                <datalist id="serialNoList">
                                    {machines?.map((u) => (<option key={u.MachineId} value={u.SerialNo}/>))}
                                </datalist>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("consoleMachineName") && (
                             <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Automat</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.consoleMachineName === "") && "col-11"}`} list="consoleMachineNameList" placeholder="Szukaj..." defaultValue={filter?.consoleMachineName} onChange={(e) => updateMachine("consoleMachineName", "consoleMachineId", e.target.value, consoleMachines)}/>
                                    {!(filter?.consoleMachineName === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; update("consoleMachineName", input.value, {list: consoleMachines, nameKey: "Name", idKey: "MachineId", idStateKey: "consoleMachineId"})}}/>)}
                                </div>
                                    <datalist id="consoleMachineNameList">
                                        {consoleMachines?.map((m) => (<option key={m.MachineId} value={`${m.Name} (${m.SerialNo})`}/>))}
                                    </datalist>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("terminalTypeId") && (
                             <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Typ Terminala</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.terminalTypeName === "") && "col-11"}`} list="terminalTypeNameList" placeholder="Szukaj..." defaultValue={filter?.terminalTypeName} onChange={(e) => update("terminalTypeName", e.target.value, {list: terminalTypes, nameKey: "Name", idKey: "TerminalTypeId", idStateKey: "terminalTypeId"})}/>
                                    {!(filter?.terminalTypeName === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; update("terminalTypeName", input.value, {list: terminalTypes, nameKey: "Name", idKey: "TerminalTypeId", idStateKey: "terminalTypeId"})}}/>)}
                                </div>
                                <datalist id="terminalTypeNameList">
                                    {terminalTypes?.map((t) => (<option key={t.TerminalTypeId} value={t.Name}/>))}
                                </datalist>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("transactionPeriod") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Transakcje</h6>
                                <select
                                    className="form-control rounded-0"
                                    value={filter?.transactionPeriod || "3d"}
                                    onChange={(e) => update("transactionPeriod", e.target.value)}
                                >
                                    <option value="1d">Ostatni dzień</option>
                                    <option value="3d">Ostatnie 3 dni</option>
                                    <option value="7d">Ostatnie 7 dni</option>
                                    <option value="month">Od początku miesiąca</option>
                                </select>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("paymentTypeId") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Typ płatności</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.paymentTypeName === "") && "col-11"}`} list="paymentTypeNameList" placeholder="Szukaj..." defaultValue={filter?.paymentTypeName} onChange={(e) => update("paymentTypeName", e.target.value, {list: paymentTypes, nameKey: "Name", idKey: "PaymentTypeId", idStateKey: "paymentTypeId"})}/>
                                    {!(filter?.paymentTypeName === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; update("paymentTypeName", null, {list: paymentTypes, nameKey: "Name", idKey: "PaymentTypeId", idStateKey: "paymentTypeId"})}}/>)}
                                </div>
                                <datalist id="paymentTypeNameList">
                                    {paymentTypes?.map((p) => (
                                         <option key={p.PaymentTypeId} value={p.Name}/>
                                    ))}
                                </datalist>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("userName") && (
                            <div className={hasDateRange ? (visibleFiltersCount > 2 ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-12 col-xl-12 col-xxl-4 px-2 py-1") : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Serwisant</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.userName === "") && "col-11"}`} list="userNameList" placeholder="Szukaj..." defaultValue={filter?.userName} onChange={(e) => update("userName", e.target.value, {list: users, nameKey: "Name", idKey: "UserId", idStateKey: "userId"})}/>
                                    {!(filter?.userName === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; update("userName", "", {list: users, nameKey: "Name", idKey: "UserId", idStateKey: "userId"})}}/>)}
                                </div>
                                <datalist id="userNameList">
                                    {users?.map((u) => (<option key={u.UserId} value={u.Name}/>))}
                                </datalist>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("terminalSerialNo") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Numer seryjny</h6>
                                <div className='d-flex flex-row'>
                                    <input
                                        className={`form-control rounded-0 ${!(filter?.terminalSerialNo === "") ? "col-11" : ""}`}
                                        placeholder="Szukaj..."
                                        value={filter?.terminalSerialNo || ""}
                                        onChange={(e) => update("terminalSerialNo", e.target.value)}
                                    />
                                    {!(filter?.terminalSerialNo === "") && (
                                        <i
                                            className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0"
                                            onClick={() => update("terminalSerialNo", "")}
                                        />
                                    )}
                                </div>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("configName") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Nazwa konfiguracji</h6>
                                <div className='d-flex flex-row'>
                                    <input
                                        className={`form-control rounded-0 ${!(filter?.configName === "") ? "col-11" : ""}`}
                                        placeholder="Szukaj..."
                                        value={filter?.configName || ""}
                                        onChange={(e) => update("configName", e.target.value)}
                                    />
                                    {!(filter?.configName === "") && (
                                        <i
                                            className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0"
                                            onClick={() => update("configName", "")}
                                        />
                                    )}
                                </div>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("locationName") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Lokalizacja</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.locationName === "") && "col-11"}`} list="locationNameList" placeholder="Szukaj..." defaultValue={filter?.locationName} onChange={(e) => update("locationName", e.target.value, {list: locations, nameKey: "Name", idKey: "LocationId", idStateKey: "locationId"})}/>
                                    {!(filter?.locationName === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; update("locationName", "", {list: locations, nameKey: "Name", idKey: "LocationId", idStateKey: "locationId"})}}/>)}
                                </div>
                                <datalist id="locationNameList">
                                    {locations?.map((u) => (<option key={u.LocationId} value={u.Name}/>))}
                                </datalist>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("machineTypeName") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Typ</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.machineTypeName === "") && "col-11"}`} list="machineTypeNameList" placeholder="Szukaj..." defaultValue={filter?.machineTypeName} onChange={(e) => update("machineTypeName", e.target.value, {list: machineTypes, nameKey: "Name", idKey: "MachineTypeId", idStateKey: "machineTypeId"})}/>
                                    {!(filter?.machineTypeName === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; update("machineTypeName", "", {list: machineTypes, nameKey: "Name", idKey: "MachineTypeId", idStateKey: "machineTypeId"})}}/>)}
                                </div>
                                <datalist id="machineTypeNameList">
                                    {machineTypes?.map((u) => (<option key={u.MachineTypeId} value={u.Name}/>))}
                                </datalist>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("maintenanceName") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Tryb obsługi</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.maintenanceName === "") && "col-11"}`} list="maintenanceNameList" placeholder="Szukaj..." defaultValue={filter?.maintenanceName} onChange={(e) => update("maintenanceName", e.target.value, {list: maintenanceTypes, nameKey: "Name", idKey: "MaintenanceTypeId", idStateKey: "maintenanceTypeId"})}/>
                                    {!(filter?.maintenanceName === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; update("maintenanceName", "", {list: maintenanceTypes, nameKey: "Name", idKey: "MaintenanceTypeId", idStateKey: "maintenanceTypeId"})}}/>)}
                                </div>
                                <datalist id="maintenanceNameList">
                                    {maintenanceTypes?.map((u) => (<option key={u.MaintenanceTypeId} value={u.Name}/>))}
                                </datalist>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("tagName") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Nazwa</h6>
                                <div className='d-flex flex-row'>
                        <input
                            className={`form-control rounded-0 ${!(filter?.tagName === "") ? "col-11" : ""}`}
                            list="tagNameList"
                            placeholder="Szukaj..."
                            value={filter?.tagName || ""}
                            onChange={(e) => update("tagName", e.target.value)}
                        />
                                    {!(filter?.tagName === "") && (
                                        <i
                                            className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0"
                                            onClick={() => update("tagName", "")}
                                        />
                                    )}
                                </div>
                        <datalist id="tagNameList">
                            {[...new Set(tagNames?.map(tag => String(tag.Name || "").split(" - ")[0].trim()).filter(Boolean))].map(name => (
                                <option key={name} value={name} />
                            ))}
                        </datalist>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("manufacturerName") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Nazwa</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.manufacturerName === "") && "col-11"}`} list="manufacturerNameList" placeholder="Szukaj..." defaultValue={filter?.manufacturerName} onChange={(e) => update("manufacturerName", e.target.value, {list: manufacturers, nameKey: "Name", idKey: "ManufacturerId", idStateKey: "manufacturerId"})}/>
                                    {!(filter?.manufacturerName === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; update("manufacturerName", "", {list: manufacturers, nameKey: "Name", idKey: "ManufacturerId", idStateKey: "manufacturerId"})}}/>)}
                                </div>
                                <datalist id="manufacturerNameList">
                                    {manufacturers?.map((u) => (<option key={u.ManufacturerId} value={u.Name}/>))}
                                </datalist>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("code") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Kod</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.code === "") && "col-11"}`} list="codeList" placeholder="Szukaj..." defaultValue={filter?.code} onChange={(e) => update("code", e.target.value, {list: manufacturers, nameKey: "Code", idKey: "ManufacturerId", idStateKey: "manufacturerId"})}/>
                                    {!(filter?.code === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; update("code", "", {list: manufacturers, nameKey: "Code", idKey: "ManufacturerId", idStateKey: "manufacturerId"})}}/>)}
                                </div>
                                <datalist id="codeList">
                                    {manufacturers?.map((u) => (<option key={u.ManufacturerId} value={u.Code}/>))}
                                </datalist>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("contractorName") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Kontrahent</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.contractorName === "") && "col-11"}`} list="contractorNameList" placeholder="Szukaj..." defaultValue={filter?.contractorName} onChange={(e) => update("contractorName", e.target.value, {list: contractors, nameKey: "Name", idKey: "ContractorId", idStateKey: "contractorId"})}/>
                                    {!(filter?.contractorName === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; update("contractorName", "", {list: contractors, nameKey: "Name", idKey: "ContractorId", idStateKey: "contractorId"})}}/>)}
                                </div>
                                <datalist id="contractorNameList">
                                    {contractors?.map((u) => (<option key={u.ContractorId} value={u.Name}/>))}
                                </datalist>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("warehouseName") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Magazyn</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.warehouseName === "") && "col-11"}`} list="warehouseNameList" placeholder="Szukaj..." defaultValue={filter?.warehouseName} onChange={(e) => update("warehouseName", e.target.value, {list: warehouses, nameKey: "Name", idKey: "WarehouseId", idStateKey: "warehouseId"})}/>
                                    {!(filter?.warehouseName === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; update("warehouseName", "", {list: warehouses, nameKey: "Name", idKey: "WarehouseId", idStateKey: "warehouseId"})}}/>)}
                                </div>
                                <datalist id="warehouseNameList">
                                    {warehouses?.map((u) => (<option key={u.WarehouseId} value={u.Name}/>))}
                                </datalist>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("nrUnikName") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Nr unikatowy</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.nrUnikName === "") && "col-11"}`} list="nrUnikNameList" placeholder="Szukaj..." defaultValue={filter?.nrUnikName} onChange={(e) => update("nrUnikName", e.target.value, {list: cashRegisters, nameKey: "NrUnik", idKey: "CashRegisterId", idStateKey: "cashRegisterId"})}/>
                                    {!(filter?.nrUnikName === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; update("nrUnikName", "", {list: cashRegisters, nameKey: "NrUnik", idKey: "CashRegisterId", idStateKey: "cashRegisterId"})}}/>)}
                                </div>
                                <datalist id="nrUnikNameList">
                                    {cashRegisters?.map((u) => (<option key={u.CashRegisterId} value={u.NrUnik}/>))}
                                </datalist>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("fiscalDocTypeName") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Typ dokumentu</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.fiscalDocTypeName === "") && "col-11"}`} list="fiscalDocTypeNameList" placeholder="Szukaj..." defaultValue={filter?.fiscalDocTypeName} onChange={(e) => update("fiscalDocTypeName", e.target.value, {list: fiscDocs, nameKey: "Name", idKey: "FiscalDocTypeId", idStateKey: "fiscalDocTypeId"})}/>
                                    {!(filter?.fiscalDocTypeName === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; update("fiscalDocTypeName", "", {list: fiscDocs, nameKey: "Name", idKey: "FiscalDocTypeId", idStateKey: "fiscalDocTypeId"})}}/>)}
                                </div>
                                <datalist id="fiscalDocTypeNameList">
                                    {fiscDocs?.map((u) => (<option key={u.FiscalDocTypeId} value={u.Name}/>))}
                                </datalist>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("roleName") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Rola</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.roleName === "") && "col-11"}`} list="RoleNameList" placeholder="Szukaj..." defaultValue={filter?.roleName} onChange={(e) => update("roleName", e.target.value, {list: roles, nameKey: "Name", idKey: "RoleId", idStateKey: "roleId"})}/>
                                    {!(filter?.roleName === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; update("roleName", "", {list: roles, nameKey: "Name", idKey: "RoleId", idStateKey: "roleId"})}}/>)}
                                </div>
                                <datalist id="RoleNameList">
                                    {roles?.map((u) => (<option key={u.RoleId} value={u.Name}/>))}
                                </datalist>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("ownerData") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Właściciel karty prepaid</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.ownerData === "") && "col-11"}`} list="OwnerDataList" placeholder="Szukaj..." defaultValue={filter?.ownerData} onChange={(e) => update("ownerData", e.target.value, {list: prepaids, nameKey: "OwnerData", idKey: "PrepaidId", idStateKey: "prepaidId"})}/>
                                    {!(filter?.ownerData === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; update("ownerData", "", {list: prepaids, nameKey: "OwnerData", idKey: "PrepaidId", idStateKey: "prepaidId"})}}/>)}
                                </div>
                                <datalist id="OwnerDataList">
                                    {prepaids?.map((u) => (<option key={u.PrepaidId} value={u.OwnerData}/>))}
                                </datalist>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("printedCodeName") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Nadrukowany numer karty</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.printedCodeName === "") && "col-11"}`} list="printedCodeNameList" placeholder="Szukaj..." defaultValue={filter?.printedCodeName} onChange={(e) => update("printedCodeName", e.target.value, {list: prepaids, nameKey: "PrintedCode", idKey: "PrepaidId", idStateKey: "prepaidId"})}/>
                                    {!(filter?.printedCodeName === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; update("printedCodeName", "", {list: prepaids, nameKey: "PrintedCode", idKey: "PrepaidId", idStateKey: "prepaidId"})}}/>)}
                                </div>
                                <datalist id="printedCodeNameList">
                                    {prepaids?.map((u) => (<option key={u.PrepaidId} value={u.PrintedCode}/>))}
                                </datalist>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("codeName") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Wewnętrzny numer karty</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.codeName === "") && "col-11"}`} list="codeNameList" placeholder="Szukaj..." defaultValue={filter?.codeName} onChange={(e) => update("codeName", e.target.value, {list: prepaids, nameKey: "Code", idKey: "PrepaidId", idStateKey: "prepaidId"})}/>
                                    {!(filter?.codeName === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; update("codeName", "", {list: prepaids, nameKey: "Code", idKey: "PrepaidId", idStateKey: "prepaidId"})}}/>)}
                                </div>
                                <datalist id="codeNameList">
                                    {prepaids?.map((u) => (<option key={u.PrepaidId} value={u.Code}/>))}
                                </datalist>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("groupName") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Grupa prepaid</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.groupName === "") && "col-11"}`} list="groupNameList" placeholder="Szukaj..." defaultValue={filter?.groupName} onChange={(e) => update("groupName", e.target.value, {list: prepaids, nameKey: "GroupName", idKey: "PrepaidGroupId", idStateKey: "prepaidGroupId"})}/>
                                    {!(filter?.groupName === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; update("groupName", "", {list: prepaids, nameKey: "GroupName", idKey: "PrepaidGroupId", idStateKey: "prepaidGroupId"})}}/>)}
                                </div>
                                <datalist id="groupNameList">
                                    {prepaids?.map((u) => (<option key={u.PrepaidId} value={u.GroupName}/>))}
                                </datalist>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("prepaidStatus") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Status transakcji</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.prepaidStatus === "") && "col-11"}`} list="prepaidStatusList" placeholder="Szukaj..." defaultValue={filter?.prepaidStatus} onChange={(e) => update("prepaidStatus", e.target.value, {list: prepaidStatuses, nameKey: "Name", idKey: "PrepaidStatusId", idStateKey: "prepaidStatusId"})}/>
                                    {!(filter?.prepaidStatus === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; update("prepaidStatus", "", {list: prepaidStatuses, nameKey: "Name", idKey: "PrepaidStatusId", idStateKey: "prepaidStatusId"})}}/>)}
                                </div>
                                <datalist id="prepaidStatusList">
                                    {prepaidStatuses?.map((u) => (<option key={u.PrepaidStatusId} value={u.Name}/>))}
                                </datalist>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("prepaidType") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Typ karty prepaid</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.prepaidType === "") && "col-11"}`} list="prepaidTypeList" placeholder="Szukaj..." defaultValue={filter?.prepaidType} onChange={(e) => update("prepaidType", e.target.value, {list: prepaidTypes, nameKey: "Name", idKey: "PrepaidTypeId", idStateKey: "prepaidTypeId"})}/>
                                    {!(filter?.prepaidType === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; update("prepaidType", "", {list: prepaidTypes, nameKey: "Name", idKey: "PrepaidTypeId", idStateKey: "prepaidTypeId"})}}/>)}
                                </div>
                                <datalist id="prepaidTypeList">
                                    {prepaidTypes?.map((u) => (<option key={u.PrepaidTypeId} value={u.Name}/>))}
                                </datalist>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("merchantName") && (
                             <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Kontrahent</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.merchantName === "") && "col-11"}`} list="merchantNameList" placeholder="Szukaj..." defaultValue={filter?.merchantName} onChange={(e) => update("merchantName", e.target.value, {list: merchants, nameKey: "name", idKey: "mid", idStateKey: "merchantMid"})}/>
                                    {!(filter?.merchantName === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; update("merchantName", input.value, {list: machines, nameKey: "name", idKey: "mid", idStateKey: "merchantMid"})}}/>)}
                                </div>
                                    <datalist id="merchantNameList">
                                        {merchants?.map((m) => (<option key={m.mid} value={m.name}/>))}
                                    </datalist>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("deviceSN") && (
                             <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Urządzenie</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.deviceSN === "" || filter?.deviceModel === null) && "col-11"}`} list="deviceSNList" placeholder="Szukaj..." defaultValue={filter?.deviceSN} onChange={(e) => update("deviceSN", e.target.value, {list: devices, nameKey: "sn", idKey: "sn", idStateKey: "deviceSN"})}/>
                                    {!(filter?.deviceSN === "" || filter?.deviceSN === null) && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; update("deviceSN", input.value, {list: devices, nameKey: "sn", idKey: "sn", idStateKey: "deviceSN"})}}/>)}
                                </div>
                                    <datalist id="deviceSNList">
                                        {devices?.map((m) => (<option key={m.sn} value={m.sn}/>))}
                                    </datalist>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("deviceModel") && (
                             <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Model urządzenia</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.deviceModel === "" || filter?.deviceModel === null) && "col-11"}`} list="deviceModelList" placeholder="Szukaj..." defaultValue={filter?.deviceModel} onChange={(e) => update("deviceModel", e.target.value, {list: devicesModels, nameKey: "model", idKey: "model", idStateKey: "deviceModel"})}/>
                                    {!(filter?.deviceModel === "" || filter?.deviceModel === null) && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; update("deviceModel", input.value, {list: devicesModels, nameKey: "model", idKey: "model", idStateKey: "deviceModel"})}}/>)}
                                </div>
                                    <datalist id="deviceModelList">
                                        {devicesModels?.map((m) => (<option key={m.model} value={m.model}/>))}
                                    </datalist>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("eanPName") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">EAN</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.eanPName === "") && "col-11"}`} list="eanPNameList" placeholder="Szukaj..." defaultValue={filter?.eanPName} onChange={(e) => update("eanPName", e.target.value, {list: products, nameKey: "EAN", idKey: "ProductId", idStateKey: "productId"})}/>
                                    {!(filter?.eanPName === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; update("eanPName", "", {list: products, nameKey: "EAN", idKey: "ProductId", idStateKey: "productId"})}}/>)}
                                </div>
                                <datalist id="eanPNameList">
                                    {products?.map((u) => (<option key={u.ProductId} value={u.EAN}/>))}
                                </datalist>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("productName") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Nazwa</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.productName === "") && "col-11"}`} list="productNameList" placeholder="Szukaj..." defaultValue={filter?.productName} onChange={(e) => update("productName", e.target.value, {list: products, nameKey: "Name", idKey: "ProductId", idStateKey: "productId"})}/>
                                    {!(filter?.productName === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; update("productName", "", {list: products, nameKey: "Name", idKey: "ProductId", idStateKey: "productId"})}}/>)}
                                </div>
                                <datalist id="productNameList">
                                    {products?.map((u) => (<option key={u.ProductId} value={u.Name}/>))}
                                </datalist>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("categoryName") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Nazwa</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.categoryName === "") && "col-11"}`} list="categoryNameList" placeholder="Szukaj..." defaultValue={filter?.categoryName} onChange={(e) => update("categoryName", e.target.value, {list: categories, nameKey: "Name", idKey: "CategoryId", idStateKey: "categoryId"})}/>
                                    {!(filter?.categoryName === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; update("categoryName", "", {list: categories, nameKey: "Name", idKey: "CategoryId", idStateKey: "categoryId"})}}/>)}
                                </div>
                                <datalist id="categoryNameList">
                                    {categories?.map((u) => (<option key={u.CategoryId} value={u.Name}/>))}
                                </datalist>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("eanRName") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">EAN</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.eanRName === "") && "col-11"}`} list="eanRNameList" placeholder="Szukaj..." defaultValue={filter?.eanRName} onChange={(e) => update("eanRName", e.target.value, {list: recipes, nameKey: "EAN", idKey: "RecipeId", idStateKey: "recipeId"})}/>
                                    {!(filter?.eanRName === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; update("eanRName", "", {list: recipes, nameKey: "EAN", idKey: "RecipeId", idStateKey: "recipeId"})}}/>)}
                                </div>
                                <datalist id="eanRNameList">
                                    {recipes?.map((u) => (<option key={u.RecipeId} value={u.EAN}/>))}
                                </datalist>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("recipeName") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Nazwa</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.recipeName === "") && "col-11"}`} list="recipeNameList" placeholder="Szukaj..." defaultValue={filter?.recipeName} onChange={(e) => update("recipeName", e.target.value, {list: recipes, nameKey: "Name", idKey: "RecipeId", idStateKey: "recipeId"})}/>
                                    {!(filter?.recipeName === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; update("recipeName", "", {list: recipes, nameKey: "Name", idKey: "RecipeId", idStateKey: "recipeId"})}}/>)}
                                </div>
                                <datalist id="recipeNameList">
                                    {recipes?.map((u) => (<option key={u.RecipeId} value={u.Name}/>))}
                                </datalist>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("VATName") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Stawka VAT</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.VATName === "") && "col-11"}`} list="VATNameList" placeholder="Szukaj..." defaultValue={filter?.VATName} onChange={(e) => update("VATName", e.target.value, {list: VATs, nameKey: "Name", idKey: "Code", idStateKey: "VATCode"})}/>
                                    {!(filter?.VATName === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; update("VATName", "", {list: VATs, nameKey: "Name", idKey: "Code", idStateKey: "VATCode"})}}/>)}
                                </div>
                                <datalist id="VATNameList">
                                    {VATs?.map((u) => (<option key={u.Code} value={u.Name}/>))}
                                </datalist>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("depositName") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Kaucja</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.depositName === "") && "col-11"}`} list="depositNameList" placeholder="Szukaj..." defaultValue={filter?.depositName} onChange={(e) => update("depositName", e.target.value, {list: deposits, nameKey: "Name", idKey: "DepositId", idStateKey: "depositId"})}/>
                                    {!(filter?.depositName === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; update("depositName", "", {list: deposits, nameKey: "Name", idKey: "DepositId", idStateKey: "depositId"})}}/>)}
                                </div>
                                <datalist id="depositNameList">
                                    {deposits?.map((d) => (<option key={d.DepositId} value={d.Name}/>))}
                                </datalist>
                            </div>
                        )}

                        {Object.keys(defaultFilter).includes("customerName") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Klient</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.customerName === "") && "col-11"}`} list="customerNameList" placeholder="Szukaj..." defaultValue={filter?.customerName} onChange={(e) => update("customerName", e.target.value, {list: customers, nameKey: "Name", idKey: "CustomerId", idStateKey: "customerId"})}/>
                                    {!(filter?.customerName === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; update("customerName", "", {list: customers, nameKey: "Name", idKey: "CustomerId", idStateKey: "customerId"})}}/>)}
                                </div>
                                <datalist id="customerNameList">
                                    {customers?.map((u) => (<option key={u.CustomerId} value={u.Name}/>))}
                                </datalist>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("prepaidGroupName") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Nazwa</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.prepaidGroupName === "") && "col-11"}`} list="prepaidGroupNameList" placeholder="Szukaj..." defaultValue={filter?.prepaidGroupName} onChange={(e) => update("prepaidGroupName", e.target.value, {list: prepaidGroup, nameKey: "PrepaidGroupName", idKey: "PrepaidGroupId", idStateKey: "prepaidGroupId"})}/>
                                    {!(filter?.prepaidGroupName === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; update("prepaidGroupName", "", {list: prepaidGroup, nameKey: "PrepaidGroupName", idKey: "PrepaidGroupId", idStateKey: "prepaidGroupId"})}}/>)}
                                </div>
                                <datalist id="prepaidGroupNameList">
                                    {prepaidGroup?.map((u) => (<option key={u.PrepaidGroupId} value={u.PrepaidGroupName}/>))}
                                </datalist>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("prepaidTimespanName") && (
                        <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                            <h6 className="d-flex justify-content-center">Częstotliwość zasilania</h6>
                            <div className="d-flex flex-row">
                                <input className={`form-control rounded-0 ${filter?.prepaidTimespanName ? "col-11" : ""}`} list="prepaidTimespanList" placeholder="Szukaj..." value={filter?.prepaidTimespanName ?? ""} onChange={(e) => { const val = e.target.value; const n = val.trim().toLowerCase();
                                    const found =
                                        uniqueTimespans.find(t => t.name.toLowerCase() === n) ||
                                        uniqueTimespans.find(t => t.name.toLowerCase().startsWith(n));
                                    setFilter(prev => ({
                                        ...prev,
                                        prepaidTimespanName: val,
                                        prepaidTimespanId: found ? Number(found.id) : null,
                                    }));
                                    }}
                                />
                            {filter?.prepaidTimespanName && (
                                <i
                                className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={() =>
                                    setFilter(prev => ({
                                    ...prev,
                                    prepaidTimespanName: "",
                                    prepaidTimespanId: null,
                                    }))
                                }
                                />
                            )}
                            </div>
                            <datalist id="prepaidTimespanList">
                            {uniqueTimespans.map(t => (
                                <option key={t.id} value={t.name} />
                            ))}
                            </datalist>
                        </div>
                        )}
                        {Object.keys(defaultFilter).includes("notificationName") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Nazwa powiadomienia</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.notificationName === "") && "col-11"}`} list="notificationNameList" placeholder="Szukaj..." value={filter?.notificationName || ""} onChange={(e) => update("notificationName", e.target.value)}/>
                                    {!(filter?.notificationName === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={() => update("notificationName", "")}/>) }
                                </div>
                                <datalist id="notificationNameList">
                                    {notifications?.map((n, i) => (<option key={n.NotificationId || i} value={n.Name}/>))}
                                </datalist>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("notificationDescription") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Opis</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.notificationDescription === "") && "col-11"}`} placeholder="Szukaj..." value={filter?.notificationDescription || ""} onChange={(e) => update("notificationDescription", e.target.value)}/>
                                    {!(filter?.notificationDescription === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={() => update("notificationDescription", "")}/>) }
                                </div>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("notificationLevelName") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Poziom powiadomienia</h6>
                                <div className='d-flex flex-row'>
                                    <input className={`form-control rounded-0 ${!(filter?.notificationLevelName === "") && "col-11"}`} list="notificationLevelNameList" placeholder="Szukaj..." value={filter?.notificationLevelName || ""} onChange={(e) => update("notificationLevelName", e.target.value)}/>
                                    {!(filter?.notificationLevelName === "") && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={() => update("notificationLevelName", "")}/>) }
                                </div>
                                <datalist id="notificationLevelNameList">
                                    {notificationLevels?.map((n, i) => (<option key={n.NotificationLevelId || i} value={n.Name}/>))}
                                </datalist>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("machineFeederNo") && (
                        <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                            <h6 className="d-flex justify-content-center">Nr wyboru</h6>
                            <div className="d-flex flex-row">
                                <input className={`form-control rounded-0 ${!(String(filter?.machineFeederNo ?? "") === "") && "col-11"}`}  type="text" placeholder="Szukaj..." value={filter?.machineFeederNo ?? ""} onChange={(e) => update("machineFeederNo", e.target.value)}/>
                                {String(filter?.machineFeederNo ?? "") !== "" && (<i className="d-flex fas fa-times btn btn-outline-danger col-1 justify-content-center align-items-center rounded-0" onClick={(e) => {const input = e.target.previousSibling; input.value = ""; update("machineFeederNo", "")}}/>)}
                            </div>
                        </div>
                        )}
                        {Object.keys(defaultFilter).includes("machineLogType") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Typ zmiany</h6>
                                <select
                                    className="form-control rounded-0"
                                    value={filter?.machineLogType ?? ""}
                                    onChange={(e) => update("machineLogType", e.target.value)}
                                >
                                    <option value="">Dowolny</option>
                                    {Object.entries(machineLogTypes).map(([value, name]) => (
                                        <option key={value} value={value}>{name}</option>
                                    ))}
                                </select>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("machineLogSource") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <h6 className="d-flex justify-content-center">Źródło zmiany</h6>
                                <select
                                    className="form-control rounded-0"
                                    value={filter?.machineLogSource ?? ""}
                                    onChange={(e) => update("machineLogSource", e.target.value)}
                                >
                                    <option value="AUTOMAT">Automat</option>
                                    <option value="TRX">Transakcje</option>
                                    <option value="PORTAL">Portal</option>
                                    <option value="VISIT">Wizyty</option>
                                </select>
                            </div>
                        )}
                        {isSorted && Object.keys(defaultFilter).includes("sortBy") && (
                            <div className={hasDateRange
                                ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1"
                                : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"
                            }>
                                <h6 className="d-flex justify-content-center">Sortowanie</h6>
                                <select
                                className="form-control rounded-0"
                                value={filter?.sortBy || "none"}
                                onChange={(e) => update("sortBy", e.target.value)}
                                >
                                {sortOptions.map(o => (
                                    <option key={o.value} value={o.value}>{o.label}</option>
                                ))}
                                </select>
                        </div>
                        )}
                           {Object.keys(defaultFilter).includes("machineTags") &&
                            filterName !== "zeroSalesReport" && filterName !== "unassignedChoicesReport" && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <TagsMini filter={filter} setFilter={setFilter} list={machineTags} stateKey="machineTags" name="Tagi Automatów"/>
                            </div>
                        )}
                           {Object.keys(defaultFilter).includes("productTags") && (
                            <div className={hasDateRange ? "col-12 col-lg-12 col-xl-6 col-xxl-4 px-2 py-1" : "col-12 col-lg-6 col-xl-4 col-xxl-4 px-2 py-1"}>
                                <TagsMini filter={filter} setFilter={setFilter} list={productTags} stateKey="productTags" name="Tagi Produktów"/>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("isRecalculated") && (
                            <div className={hasDateRange ? "col-6 col-lg-6 col-xl-6 col-xxl-2 px-1 py-1" : "col-6 col-lg-6 col-xl-6 col-xxl-2 px-1 py-1"}>
                                <h6 className="d-flex justify-content-center">Rozliczone</h6>
                                <div className="d-flex justify-content-center">
                                <ToggleButtonGroup type="radio" name="isRecalculatedType" value={filter?.isRecalculated} onChange={(val) => update("isRecalculated", val)} className="toggle-group-sm rounded-pill bg-light overflow-hidden toggle-group border border-primary">
                                    <ToggleButton id="tbg-radio-1" value ={"true"} variant="outline-primary" className="btn-sm border-0 m-1 rounded-pill" >
                                        Tak
                                    </ToggleButton>
                                    <ToggleButton id="tbg-radio-2" value ={ "false"} variant="outline-primary" className="btn-sm border-0 m-1 rounded-pill" >
                                        Nie
                                    </ToggleButton>
                                    <ToggleButton id="tbg-radio-3" value ={"null"} variant="outline-primary" className="btn-sm border-0 m-1 rounded-pill" >
                                        Dowolne
                                    </ToggleButton>
                                </ToggleButtonGroup>
                                </div>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("zeroPA") && (
                            <div className={hasDateRange ? "col-6 col-lg-6 col-xl-3 col-xxl-2 px-1 py-1" : "col-6 col-lg-3 col-xl-2 col-xxl-2 px-1 py-1"}>
                                <h6 className="d-flex justify-content-center">Zerowe PA</h6>
                                <div className="d-flex justify-content-center">
                                <ToggleButtonGroup type="radio" name="zeroPAType" value={filter?.zeroPA} onChange={(val) => update("zeroPA", val)} className="toggle-group-sm rounded-pill bg-light overflow-hidden toggle-group border border-primary">
                                    <ToggleButton id="tbg-radio-1" value ={"true"} variant="outline-primary" className="btn-sm border-0 m-1 rounded-pill" >
                                        Tak
                                    </ToggleButton>
                                    <ToggleButton id="tbg-radio-2" value ={"false"} variant="outline-primary" className="btn-sm border-0 m-1 rounded-pill" >
                                        Nie
                                    </ToggleButton>
                                    <ToggleButton id="tbg-radio-3" value ={"null"} variant="outline-primary" className="btn-sm border-0 m-1 rounded-pill" >
                                        Dowolne
                                    </ToggleButton>
                                </ToggleButtonGroup>
                                </div>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("telemetry") && (
                            <div className={hasDateRange ? "col-6 col-lg-6 col-xl-3 col-xxl-2 px-1 py-1" : "col-6 col-lg-3 col-xl-2 col-xxl-2 px-1 py-1"}>
                                <h6 className="d-flex justify-content-center">Telemetria</h6>
                                <div className="d-flex justify-content-center">
                                <ToggleButtonGroup type="radio" name="telemetryType" value={filter?.telemetry} onChange={(val) => update("telemetry", val)} className="toggle-group-sm rounded-pill bg-light overflow-hidden toggle-group border border-primary">
                                    <ToggleButton id="tbg-radio-1" value ={"true"} variant="outline-primary" className="btn-sm border-0 m-1 rounded-pill" >
                                        Tak
                                    </ToggleButton>
                                    <ToggleButton id="tbg-radio-2" value ={"false"} variant="outline-primary" className="btn-sm border-0 m-1 rounded-pill" >
                                        Nie
                                    </ToggleButton>
                                    <ToggleButton id="tbg-radio-3" value ={"null"} variant="outline-primary" className="btn-sm border-0 m-1 rounded-pill" >
                                        Dowolne
                                    </ToggleButton>
                                </ToggleButtonGroup>
                                </div>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("isIngredient") && (
                            <div className={hasDateRange ? "col-6 col-lg-6 col-xl-6 col-xxl-2 px-1 py-1" : "col-6 col-lg-6 col-xl-6 col-xxl-2 px-1 py-1"}>
                                <h6 className="d-flex justify-content-center">Składnik</h6>
                                <div className="d-flex justify-content-center">
                                <ToggleButtonGroup type="radio" name="isIngredientType" value={filter?.isIngredient} onChange={(val) => update("isIngredient", val)} className="toggle-group-sm rounded-pill bg-light overflow-hidden toggle-group border border-primary">
                                    <ToggleButton id="tbg-radio-1" value ={"true"} variant="outline-primary" className="btn-sm border-0 m-1 rounded-pill" >
                                        Tak
                                    </ToggleButton>
                                    <ToggleButton id="tbg-radio-2" value ={"false"} variant="outline-primary" className="btn-sm border-0 m-1 rounded-pill" >
                                        Nie
                                    </ToggleButton>
                                    <ToggleButton id="tbg-radio-3" value ={"null"} variant="outline-primary" className="btn-sm border-0 m-1 rounded-pill" >
                                        Dowolne
                                    </ToggleButton>
                                </ToggleButtonGroup>
                                </div>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("isActive") && (
                            <div className={toggleWrapperClass}>
                                <h6 className="d-flex justify-content-center">Aktywny</h6>
                                <div className="d-flex justify-content-center">
                                <ToggleButtonGroup type="radio" name="activeType" value={filter?.isActive} onChange={(val) => update("isActive", val)} className="toggle-group-sm rounded-pill bg-light overflow-hidden toggle-group border border-primary">
                                    <ToggleButton id="tbg-radio-1" value ={"true"} variant="outline-primary" className="btn-sm border-0 m-1 rounded-pill" >
                                        Tak
                                    </ToggleButton>
                                    <ToggleButton id="tbg-radio-2" value ={"false"} variant="outline-primary" className="btn-sm border-0 m-1 rounded-pill" >
                                        Nie
                                    </ToggleButton>
                                    <ToggleButton id="tbg-radio-3" value ={"null"} variant="outline-primary" className="btn-sm border-0 m-1 rounded-pill" >
                                        Dowolne
                                    </ToggleButton>
                                </ToggleButtonGroup>
                                </div>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("deviceAssignmentStatus") && (
                            <div className={toggleWrapperClass}>
                                <h6 className="d-flex justify-content-center">Status powiązania</h6>
                                <div className="d-flex justify-content-center">
                                    <ToggleButtonGroup type="radio" name="deviceAssignmentStatus" value={filter?.deviceAssignmentStatus} onChange={(val) => update("deviceAssignmentStatus", val)} className="toggle-group-sm rounded-pill bg-light overflow-hidden toggle-group border border-primary">
                                        <ToggleButton id="device-assignment-bound" value="BOUND" variant="outline-primary" className="btn-sm border-0 m-1 rounded-pill">
                                            Powiązane
                                        </ToggleButton>
                                        <ToggleButton id="device-assignment-terminal-only" value="TERMINAL_ONLY" variant="outline-primary" className="btn-sm border-0 m-1 rounded-pill">
                                            Puste terminale
                                        </ToggleButton>
                                        <ToggleButton id="device-assignment-device-only" value="DEVICE_ONLY" variant="outline-primary" className="btn-sm border-0 m-1 rounded-pill">
                                            Puste urządzenia
                                        </ToggleButton>
                                        <ToggleButton id="device-assignment-any" value="NULL" variant="outline-primary" className="btn-sm border-0 m-1 rounded-pill">
                                            Dowolne
                                        </ToggleButton>
                                    </ToggleButtonGroup>
                                </div>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("enabled") && (
                            <div className={toggleWrapperClass}>
                                <h6 className="d-flex justify-content-center">Włączona</h6>
                                <div className="d-flex justify-content-center">
                                <ToggleButtonGroup type="radio" name="enabledType" value={filter?.enabled} onChange={(val) => update("enabled", val)} className="toggle-group-sm rounded-pill bg-light overflow-hidden toggle-group border border-primary">
                                    <ToggleButton id="tbg-radio-1" value ={"true"} variant="outline-primary" className="btn-sm border-0 m-1 rounded-pill" >
                                        Tak
                                    </ToggleButton>
                                    <ToggleButton id="tbg-radio-2" value ={"false"} variant="outline-primary" className="btn-sm border-0 m-1 rounded-pill" >
                                        Nie
                                    </ToggleButton>
                                    <ToggleButton id="tbg-radio-3" value ={"null"} variant="outline-primary" className="btn-sm border-0 m-1 rounded-pill" >
                                        Dowolne
                                    </ToggleButton>
                                </ToggleButtonGroup>
                                </div>
                            </div>
                        )}
                        {Object.keys(defaultFilter).includes("overwriteCredit") && (
                            <div className={toggleWrapperClass}>
                                <h6 className="d-flex justify-content-center">Nadpisywanie środków</h6>
                                <div className="d-flex justify-content-center">
                                <ToggleButtonGroup type="radio" name="overwriteCreditType" value={filter?.overwriteCredit} onChange={(val) => update("overwriteCredit", val)} className="toggle-group-sm rounded-pill bg-light overflow-hidden toggle-group border border-primary">
                                    <ToggleButton id="tbg-radio-1" value ={"true"} variant="outline-primary" className="btn-sm border-0 m-1 rounded-pill" >
                                        Tak
                                    </ToggleButton>
                                    <ToggleButton id="tbg-radio-2" value ={"false"} variant="outline-primary" className="btn-sm border-0 m-1 rounded-pill" >
                                        Nie
                                    </ToggleButton>
                                    <ToggleButton id="tbg-radio-3" value ={"null"} variant="outline-primary" className="btn-sm border-0 m-1 rounded-pill" >
                                        Dowolne
                                    </ToggleButton>
                                </ToggleButtonGroup>
                                </div>
                            </div>
                        )}
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="d-flex justify-content-between p-0">
                    <button className="btn btn-secondary" onClick={() => setIsFilterOpen(false)}>Zamknij</button>
                    <div>
                        <button className="btn btn-danger mr-2" onClick={() => clearFilter()}>Domyślne</button>
                        <button className="btn btn-primary" onClick={() => applyFilter()}>Szukaj</button>
                    </div>
                </Modal.Footer>
            </Modal>
            
        </div>
    )
}